import { Global, BaoCao } from '../shared/global';
export const Home = {
    id: '77CCC1E2-FDBC-4644-9C99-3AB9EC1B741E',
    text: 'Trang chủ',
    link: '/home',
    icon: 'fa fa-home'
};
export const taisan_mua = {
  id: 'C1EA12BA-A424-4DC0-BAD4-809FED778768',
  text: 'Mua tài sản',
  link: '/ketoan/muataisan',
  huongdan: Global.App_url
};
export const taisan_nhanhienvat = {
  id: '401FF54E-6EB1-4C79-AA18-D66144345C56',
  text: 'Nhận hiện vật',
  link: '/ketoan/nhanhienvat',
  huongdan: Global.App_url,
  border: 'Co'
};
export const taisan_ghigiam = {
  id: 'A5581D07-8A95-4519-9BD2-BEA2E0E43F8A',
  text: 'Ghi giảm tài sản',
  link: '/ketoan/ghigiamtaisan',
  huongdan: Global.App_url
};
export const taisan_danhgia = {
  id: '6AB780E6-414F-49C3-90C9-7768365D1CE4',
  text: 'Đánh giá tài sản',
  link: '/ketoan/danhgiataisan',
  huongdan: Global.App_url
};
export const taisan_dieuchuyentaisan = {
  id: '2342D2D6-1CC1-4ECC-802F-0BB91BE05E9D',
  text: 'Điều chuyển tài sản',
  link: '/ketoan/dieuchuyentaisan',
  huongdan: Global.App_url
};

export const taisan_ban = {
  id: '1CDCB850-A3D5-4750-A3C7-F1360A4802B1',
  text: 'Bán tài sản',
  link: '/ketoan/bantaisan',
  huongdan: Global.App_url,
  border: 'Co'
};
export const taisan_haomon = {
  id: '8EB28651-7268-4C92-AFE0-395CD1DCE370',
  text: 'Tính hao mòn tài sản',
  link: '/ketoan/tinhhaomontaisan',
  huongdan: Global.App_url
};
export const taisan_cauhinh = {
  id: '1680A97C-A0AA-4611-AF41-B67C537CA43B',
  text: 'Cấu hình khấu hao, hao mòn',
  link: '/danhmuc/cauhinhtaisan',
  huongdan: Global.App_url
};
export const TaiSans = {
    id: '', 
    text: 'Tài sản',    
  icon: 'fa fa-shopping-cart',
  submenu: [taisan_mua, taisan_nhanhienvat, taisan_danhgia, taisan_ghigiam, taisan_dieuchuyentaisan, taisan_ban, taisan_haomon]
};



//-----------------hang hóa, kho-----------------------
export const Products_muahang = {
  id: 'B82D62C4-3589-4EEC-B442-F7C85767A990',
  text: 'Mua hàng',
  link: '/ketoan/muahang',
  huongdan: Global.App_url,
  border:'Co'
};
export const Products_muacongcu = {
  id: 'CC2254F4-BEB6-4D41-A246-7722D3939ED4',
  text: 'Mua công cụ',
  link: '/ketoan/muacongcu',
  huongdan: Global.App_url,
  border: 'Co'
};
export const Products_nhapkho = {
  id: '203EEA83-2293-45E6-B80D-ED7ED80565A6',
    text: 'Nhập kho ',
  link: '/ketoan/nhapkho',
  huongdan: Global.App_url
};
export const Products_nhapkhocongcu = {
  id: 'A5725EFD-4FDF-4837-AB99-5F1F6C32CB88',
  text: 'Nhập kho công cụ',
  link: '/ketoan/nhapkhocongcu',
  huongdan: Global.App_url
};
export const Products_xuatkho = {
  id: '5CCCD93D-6444-462B-8A98-85B31691C742',
    text: 'Xuất kho ',
  link: '/ketoan/xuatkho',
    huongdan: Global.App_url
};
export const Products_xuatkhocongcu = {
  id: '03B2DC61-5C93-4E21-B552-80450E253AEA',
  text: 'Xuất kho công cụ',
  link: '/ketoan/xuatkhocongcu',
  huongdan: Global.App_url
};
export const Products_tinhgia = {
  id: '4813FA4E-2AAC-4ECF-83D8-62F0F8527160',
  text: 'Tính lại giá xuất ',
  link: '/ketoan/tinhgiaxuat',
  huongdan: Global.App_url
};
export const Products = {
    id:'',
    text: 'Hàng hóa ',
    link: '/dashboard',
    icon: 'fa fa-cube',
  submenu: [Products_muahang, Products_nhapkho, Products_xuatkho, Products_tinhgia]
};
//----------------------Bao cao-------------------------------------------------------
export const Reports_dshoadon = {
    id: 'B3FE70AF-7EA5-435B-90B4-8EF0E2409470',
    text: 'Báo cáo danh sách hóa đơn',
  link: '/baocao/hoadon',
  huongdan: Global.App_url
};
export const Reports_doanhthu = {
    id: 'F9A807DC-9AC6-446E-808A-32DDDC2FD55B',
    text: 'Báo cáo bán hàng',
  link: '/baocao/bcdoanhthu',
  huongdan: Global.App_url
};
export const Reports_nhapxuat = {
    id: '23A08226-124F-4177-ACA3-57AC517AD356',
    text: 'Báo cáo tổng hợp nhập xuất',
  link: '/baocao/bcnhapxuat',
  huongdan: Global.App_url
};
export const Reports_soquy = {
    id: '8C7443C8-7A12-4903-B27D-66EEF0947B71',
    text: 'Sổ quỹ tiền mặt',
  link: '/caidat/soquy',
  huongdan: Global.App_url
};
export const Reports_hoahong = {
    id: '476A69AD-E5CC-4188-8773-56B5A9F390B6',
    text: 'Báo cáo hoa hồng nhân viên',
  link: '/baocao/hoahong',
  huongdan: Global.App_url
};
export const Reports_ketquakinhdoanh = {
    id: '904CEA7A-532A-4DA5-B4BA-7C3D5D846FC2',
    text: 'Báo cáo kết quả kinh doanh',
  link: '/baocao/ketquakinhdoanh',
  huongdan: Global.App_url
};
export const Reports_bangtonghopchungtu = {
  id: BaoCao.BC96_BangTongHopChungTu,
  text: 'Bảng tổng hợp chứng từ',
  link: '/baocao/bangtonghopchungtu/' + BaoCao.BC96_BangTongHopChungTu,
  huongdan: Global.App_url
};
export const Reports_nhatkysocai = {
  id: BaoCao.BC97_NhatKySoCai,
  text: 'Nhật ký sổ cái',
  link: '/baocao/nhatkysocai/' + BaoCao.BC97_NhatKySoCai,
  huongdan: Global.App_url
};
export const Reports_chungtughiso = {
  id: BaoCao.BC98_ChungTuGhiSo,
  text: 'Chứng từ ghi sổ',
  link: '/baocao/chungtughiso/' + BaoCao.BC98_ChungTuGhiSo,
  huongdan: Global.App_url
};
export const Reports_sodangkychungtughiso = {
  id: BaoCao.BC99_SoDangKyChungTuGhiSo,
  text: 'Số đăng ký chứng từ ghi sổ',
  link: '/baocao/sodangkychungtughiso/' + BaoCao.BC99_SoDangKyChungTuGhiSo,
  huongdan: Global.App_url
};
export const Reports_socaihinhthucchungtughiso = {
  id: BaoCao.BC100_SoCaiHinhThucChungTuGhiSo,
  text: 'Sổ cái - hình thức chứng từ ghi sổ',
  link: '/baocao/socaihinhthucctgs/' + BaoCao.BC100_SoCaiHinhThucChungTuGhiSo,
  huongdan: Global.App_url
};



export const Reports_socaitaikhoan = {
  id: BaoCao.BC04_SoCaiTaiKhoan,
  text: 'Sổ cái -  hình thức nhật ký chung',
  link: '/baocao/socaitaikhoan/' + BaoCao.BC04_SoCaiTaiKhoan,
  huongdan: Global.App_url
};

export const Reports_sochitietdoanhthus51 = {
  id: BaoCao.BC04_SoCaiTaiKhoan,
  text: 'Sổ chi tiết doanh thu (S51-H)',
  link: '/baocao/sochitietdoanhthus51/B8A6DBAC-D04D-4778-80F3-9046729FB6BD',
  huongdan: Global.App_url
};
export const Reports_sochitietphaithukinhphiduoccap = {
  id: BaoCao.BC04_SoCaiTaiKhoan,
  text: 'Sổ chi tiết phải thu kinh phí được cấp (S31-H)',
  link: '/baocao/sochitietphaithukinhphiduoccap/4D14FE63-7ADA-41B2-BDCA-38F1D9C11CD3',
  huongdan: Global.App_url
};



export const Reports_bangkedoichieudutoanns = {
  id: BaoCao.BC09_BangDoiChieuDuToanNS,
  text: 'Bảng đối chiếu dự toán kinh phí ngân sách (Mẫu số 01-SDKP/ĐVDT)',
  link: '/baocao/bangkedoichieu/' + BaoCao.BC09_BangDoiChieuDuToanNS,
  huongdan: Global.App_url
};

export const Reports_bangkedoichieudutoanns_mau26 = {
  id: '5E2A7977-A0D7-4325-9837-23D9F35C7C55',
  text: 'Bảng đối chiếu dự toán kinh phí NS bằng hình thức rút dự toán tại KBNN Mẫu 26-NĐ347',
  link: '/baocao/bangkedoichieu26/5E2A7977-A0D7-4325-9837-23D9F35C7C55',
  huongdan: Global.App_url
};
export const Reports_bangkedoichieudutoanns_mau27 = {
  id: '1091F63C-FE3B-477A-ACF1-C22D9E760301',
  text: 'Bảng đối chiếu dự toán kinh phí NS bằng hình thức lệnh chi tiền Mẫu 27-NĐ347',
  link: '/baocao/bangkedoichieu27/1091F63C-FE3B-477A-ACF1-C22D9E760301',
  huongdan: Global.App_url
};
export const Reports_bangkedoichieudutoanns_mau28 = {
  id: '3E7D0052-C026-4A32-96B1-A13E36F110F6',
  text: 'Bảng đối chiếu dự toán kinh phí NS bằng hình thức rút dự toán tại KBNN Mẫu 28-NĐ347',
  link: '/baocao/bangkedoichieu28/3E7D0052-C026-4A32-96B1-A13E36F110F6',
  huongdan: Global.App_url
};
export const Reports_bangkedoichieudutoanns_mau29 = {
  id: '0B466517-C9EB-4107-BD97-31C6F62FC408',
  text: 'Bảng đối chiếu dự toán kinh phí NS bằng hình thức lệnh chi tiền Mẫu 29-NĐ347',
  link: '/baocao/bangkedoichieu29/0B466517-C9EB-4107-BD97-31C6F62FC408',
  huongdan: Global.App_url
};

export const Reports_bangkedoichieudutoanns_mau30 = {
  id: 'CB730481-A07C-4B37-A470-71EBA01018E9',
  text: 'Bảng đối chiếu số dư tài khoản tiền gửi kinh phí NS cấp được chuyển sang năm sau Mẫu 30-NĐ347',
  link: '/baocao/bangkedoichieu30/CB730481-A07C-4B37-A470-71EBA01018E9',
  huongdan: Global.App_url
};
export const Reports_bangkedoichieudutoanns_mau31 = {
  id: '2BF7C22F-440D-4347-B7E6-C53374E7059C',
  text: 'Bảng đối chiếu tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau Mẫu 31-NĐ347',
  link: '/baocao/bangkedoichieu31/2BF7C22F-440D-4347-B7E6-C53374E7059C',
  huongdan: Global.App_url
};
export const Reports_bangkedoichieudutoanns_mau32 = {
  id: 'E99AACAB-35CA-4B0A-95CB-16DE9687B3BA',
  text: 'Bảng xác nhận SDTK tiền gửi tại KBNN Mẫu 32 - NĐ347',
  link: '/baocao/bangkedoichieu32/E99AACAB-35CA-4B0A-95CB-16DE9687B3BA',
  huongdan: Global.App_url
};

export const Reports_bangkedoichieusudungns = {
  id: BaoCao.BC10_BangDoiChieuSuDungKP,
  text: 'Bảng đối chiếu tình hình sử dụng kinh phí NS (Mẫu số 02-SDKP/ĐVDT)',
  link: '/baocao/bangkedoichieusudungkp/' + BaoCao.BC10_BangDoiChieuSuDungKP,
  huongdan: Global.App_url
};
export const Reports_bangxacnhansodutaikhoantg = {
  id: BaoCao.BC11_BangXacNhanSoDuTaiKhoanTienGui,
  text: 'Bảng xác nhận số dư tài khoản tiền gửi (Mẫu số 05-ĐCSDTK/KBNN)',
  link: '/baocao/bangxacnhansodutktg/' + BaoCao.BC11_BangXacNhanSoDuTaiKhoanTienGui,
  huongdan: Global.App_url
};
export const Reports_thuchienkinhphingansach = {
  id: BaoCao.BC106_ChiTietThucHienKinhPhiNganSach,
  text: 'Báo cáo chi tiết thực hiện kinh phí ngân sách',
  link: '/baocao/thuchienkinhphingansach/' + BaoCao.BC106_ChiTietThucHienKinhPhiNganSach,
  huongdan: Global.App_url
};

export const Reports_socaimuclucngansach = {
  id: BaoCao.BC12_SoCaiMucLucNganSach,
  text: 'Sổ cái - mục lục ngân sách',
  link: '/baocao/socaimuclucngansach/' + BaoCao.BC12_SoCaiMucLucNganSach,
  huongdan: Global.App_url
};
export const Reports_sochitietkinhphi = {
  id: BaoCao.BC13_SoChiTietKinhPhi,
  text: 'Sổ chi tiết chi phí (S61-H)',
  link: '/baocao/sochitietkinhphi/' + BaoCao.BC13_SoChiTietKinhPhi,
  huongdan: Global.App_url
};
export const Reports_sochitietphaithuphaitra = {
  id: BaoCao.BC14_SoChiPhaiThuPhaiTraNoiBo,
  text: 'Sổ chi tiết các khoản phải thu, phải trả nội bộ (S33-H)',
  link: '/baocao/sochitietphaithuphaitra/' + BaoCao.BC14_SoChiPhaiThuPhaiTraNoiBo,
  huongdan: Global.App_url
};
export const Reports_sonhatkychung = {
  id: BaoCao.BC15_SoNhatKyChung,
  text: 'Sổ nhật ký chung (S04-H)',
  link: '/baocao/sonhatkychung/' + BaoCao.BC15_SoNhatKyChung,
  huongdan: Global.App_url
};
export const Reports_banglietkechungtuketoan = {
  id: BaoCao.BC15_SoNhatKyChung,
  text: 'Bảng liệt kê chứng từ kế toán (LK01)',
  link: '/baocao/banglietkechungtuketoan/65A5BC33-E5CE-49B7-9A18-9F3423998040',
  huongdan: Global.App_url
};

export const Reports_sotheodoitienmattiengui_ngoaite = {
  id: BaoCao.BC16_SoTheoDoiTMTG_NgoaiTe,
  text: 'Sổ theo dõi tiền mặt, tiền gửi ngoại tệ (S13-H)',
  link: '/baocao/tienmattienguingoaite/' + BaoCao.BC16_SoTheoDoiTMTG_NgoaiTe,
  huongdan: Global.App_url
};
export const Reports_socaitheonhomdoiung = {
  id: BaoCao.BC17_SoCaiTaiKhoanNhomTheoDoiUng,
  text: 'Sổ cái tài khoản nhóm theo đối ứng',
  link: '/baocao/socaitheonhomdoiung/' + BaoCao.BC17_SoCaiTaiKhoanNhomTheoDoiUng,
  huongdan: Global.App_url
};
export const Reports_sochitietcactaikhoan = {
  id: BaoCao.BC18_SoChiTietCacTaiKhoan,
  text: 'Sổ chi tiết các tài khoản (S38-H)',
  link: '/baocao/sochitietcactaikhoan/' + BaoCao.BC18_SoChiTietCacTaiKhoan,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonkinhphi = {
  id: BaoCao.BC18_01_SoTheoDoiNguonKinhPhi,
  text: 'Sổ theo dõi nguồn kinh phí',
  link: '/baocao/sotheodoinguonkinhphi/' + BaoCao.BC18_01_SoTheoDoiNguonKinhPhi,
  huongdan: Global.App_url
};
export const Reports_sochitietthanhtoanvoikh = {
  id: BaoCao.BC19_SoChiTietThanhToanVoiKhachHang,
  text: 'Sổ chi tiết thanh toán với người mua, người bán (Mẫu S34-H)',
  link: '/baocao/sochitietthanhtoanvoikh/' + BaoCao.BC19_SoChiTietThanhToanVoiKhachHang,
  huongdan: Global.App_url
};
export const Reports_sotonghoptaikhoan = {
  id: BaoCao.BC20_SoTongHopTaiKhoan,
  text: 'Sổ tổng hợp tài khoản',
  link: '/baocao/sotonghoptaikhoan/' + BaoCao.BC20_SoTongHopTaiKhoan,
  huongdan: Global.App_url
};
export const Reports_soquytienmat = {
  id: BaoCao.BC21_SoQuyTienMat,
  text: 'Sổ quỹ tiền mặt (S11-H)',
  link: '/baocao/soquytienmat/' + BaoCao.BC21_SoQuyTienMat,
  huongdan: Global.App_url
};
export const Reports_sotheodoitienmatngoaite_s13h = {
  id: '161EC323-6CDD-49E1-AF9E-0910048F3E3E',
  text: 'Sổ theo dõi tiền mặt, tiền gửi bằng ngoại tệ S13-H',
  link: '/baocao/sotienmatngoaite/161EC323-6CDD-49E1-AF9E-0910048F3E3E',
  huongdan: Global.App_url
};
export const Reports_soketoanchitiettienmat = {
  id: BaoCao.BC21_SoQuyTienMat,
  text: 'Sổ kế toán chi tiết tiền mặt (S11-H)',
  link: '/baocao/soketoanchitiettienmat/0902AB94-7858-4E25-A858-1827D84036AB',
  huongdan: Global.App_url
};

export const Reports_bangcandoisophatsinh = {
  id: BaoCao.BC22_BangCanDoiSoPhatSinh,
  text: 'Bảng cân đối số phát sinh (S05-H)',
  link: '/baocao/bangcandoisophatsinh/' + BaoCao.BC22_BangCanDoiSoPhatSinh,
  huongdan: Global.App_url
};

export const Reports_bangcandoisophatsinh_tc = {
  id: BaoCao.BC22_BangCanDoiSoPhatSinhTC,
  text: 'Bảng cân đối số phát sinh (S05-H) - Hợp nhất',
  link: '/baocao/bangcandoisophatsinhtc/' + BaoCao.BC22_BangCanDoiSoPhatSinhTC,
  huongdan: Global.App_url
};

export const Reports_sotienguinganhang = {
  id: BaoCao.BC23_SoTienGuiNganHang,
  text: 'Sổ tiền gửi ngân hàng/kho bạc (S12-H)',
  link: '/baocao/sotienguinganhang/' + BaoCao.BC23_SoTienGuiNganHang,
  huongdan: Global.App_url
};
export const Reports_sochitietsxkd = {
  id: BaoCao.BC24_SoChiPhiSanXuatKinhDoanh,
  text: 'Sổ chi phí sản xuất, kinh doanh (S62-H)',
  link: '/baocao/sochitietsxkd/' + BaoCao.BC24_SoChiPhiSanXuatKinhDoanh,
  huongdan: Global.App_url
};
export const Reports_bangkemuahang = {
  id: BaoCao.BC25_BangKeMuaHang,
  text: 'Bảng kê mua hàng (C24-HD)',
  link: '/baocao/bangkemuahang/' + BaoCao.BC25_BangKeMuaHang,
  huongdan: Global.App_url
};
export const Reports_danhsachctthanhtoan = {
  id: BaoCao.BC26_DanhSachCTThanhToanChuaCoCTMuaHang,
  text: 'Danh sách chứng từ thanh toán chưa có chứng từ mua hàng',
  link: '/baocao/danhsachctthanhtoan/' + BaoCao.BC26_DanhSachCTThanhToanChuaCoCTMuaHang,
  huongdan: Global.App_url
};
export const Reports_sochitietcongnophaitra = {
  id: BaoCao.BC27_SoChiTietCongNoPhaiTra,
  text: 'Sổ chi tiết công nợ phải trả',
  link: '/baocao/sochitietcongnophaitra/' + BaoCao.BC27_SoChiTietCongNoPhaiTra,
  huongdan: Global.App_url
};
export const Reports_sochitietcongnophaitrangoaite = {
  id: BaoCao.BC28_SoChiTietCongNoPhaiTra_NgoaiTe,
  text: 'Sổ chi tiết công nợ phải trả theo ngoại tệ',
  link: '/baocao/sochitietcongnophaitrangoaite/' + BaoCao.BC28_SoChiTietCongNoPhaiTra_NgoaiTe,
  huongdan: Global.App_url
};
export const Reports_sotonghopcongnophaitra = {
  id: BaoCao.BC29_SoTongHopCongNoPhaiTra,
  text: 'Sổ tổng hợp công nợ phải trả',
  link: '/baocao/sotonghopcongnophaitra/' + BaoCao.BC29_SoTongHopCongNoPhaiTra,
  huongdan: Global.App_url
};
export const Reports_sotonghopcongnophaitrangoaite = {
  id: BaoCao.BC30_SoTongHopCongNoPhaiTra_NgoaiTe,
  text: 'Sổ tổng hợp công nợ phải trả theo ngoại tệ',
  link: '/baocao/sotonghopcongnophaitrangoaite/' + BaoCao.BC30_SoTongHopCongNoPhaiTra_NgoaiTe,
  huongdan: Global.App_url
};
export const Reports_sochitietdoanhthu = {
  id: BaoCao.BC31_SoChiTietDoanhThu_SXKD,
  text: 'Sổ chi tiết doanh thu sản xuất, kinh doanh dịch vụ (S51-H)',
  link: '/baocao/sochitietdoanhthu/' + BaoCao.BC31_SoChiTietDoanhThu_SXKD,
  huongdan: Global.App_url
};
export const Reports_sochitietbanhang = {
  id: BaoCao.BC32_SoChiTietBanHang,
  text: 'Sổ chi tiết bán hàng',
  link: '/baocao/sochitietbanhang/' + BaoCao.BC32_SoChiTietBanHang,
  huongdan: Global.App_url
};
export const Reports_sochitietcongnophaithu = {
  id: BaoCao.BC33_SoChiTietCongNoPhaiThu,
  text: 'Sổ chi tiết công nợ phải thu',
  link: '/baocao/sochitietcongnophaithu/' + BaoCao.BC33_SoChiTietCongNoPhaiThu,
  huongdan: Global.App_url
};
export const Reports_sochitietcongnophaithungoaite = {
  id: BaoCao.BC34_SoChiTietCongNoPhaiThu_NgoaiTe,
  text: 'Sổ chi tiết công nợ phải thu theo ngoại tệ',
  link: '/baocao/sochitietcongnophaithungoaite/' + BaoCao.BC34_SoChiTietCongNoPhaiThu_NgoaiTe,
  huongdan: Global.App_url
};
export const Reports_sonhatkybanhang = {
  id: BaoCao.BC35_SoNhatKyBanHang,
  text: 'Sổ nhật ký bán hàng',
  link: '/baocao/sonhatkybanhang/' + BaoCao.BC35_SoNhatKyBanHang,
  huongdan: Global.App_url
};
export const Reports_sotonghopcongnophaithu = {
  id: BaoCao.BC36_SoTongHopCongNoPhaiThu,
  text: 'Sổ tổng hợp công nợ phải thu',
  link: '/baocao/sotonghopcongnophaithu/' + BaoCao.BC36_SoTongHopCongNoPhaiThu,
  huongdan: Global.App_url
};
export const Reports_sotonghopcongnophaithungoaite = {
  id: BaoCao.BC37_SoTongHopCongNoPhaiThu_NgoaiTe,
  text: 'Sổ tổng hợp công nợ phải thu theo ngoại tệ',
  link: '/baocao/sotonghopcongnophaithungoaite/' + BaoCao.BC37_SoTongHopCongNoPhaiThu_NgoaiTe,
  huongdan: Global.App_url
};
export const Reports_haomontscd = {
  id: BaoCao.BC38_BangTinhHaoMonTSCD,
  text: 'Bảng tính hao mòn tài sản cố định (C55-HD)',
  link: '/baocao/haomontscd/' + BaoCao.BC38_BangTinhHaoMonTSCD,
  huongdan: Global.App_url
};
export const Reports_sotaisancodinh = {
  id: BaoCao.BC39_SoTaiSanCoDinh,
  text: 'Sổ tài sản cố định (S24-H)',
  link: '/baocao/sotaisancodinh/' + BaoCao.BC39_SoTaiSanCoDinh,
  huongdan: Global.App_url
};

export const Reports_chitiettscd = {
  id: BaoCao.BC39_SoTaiSanCoDinh,
  text: 'Báo cáo chi tiết TSCĐ của đơn vị HCSN (1A/HCSN)',
  link: '/baocao/chitiettscd/EC3B1E23-67B8-457A-8C33-5A90D35E6968',
  huongdan: Global.App_url
};

export const Reports_sotheodoitscd = {
  id: BaoCao.BC40_SoTheoDoiTSCD,
  text: 'Sổ theo dõi tài sản cố định tại nơi sử dụng (S26-H)',
  link: '/baocao/sotheodoitscd/' + BaoCao.BC40_SoTheoDoiTSCD,
  huongdan: Global.App_url
};
export const Reports_kiemketscd = {
  id: BaoCao.BC41_BaoCaoKiemKeTSCD,
  text: 'Báo cáo kiểm kê tài sản cố định',
  link: '/baocao/kiemketscd/' + BaoCao.BC41_BaoCaoKiemKeTSCD,
  huongdan: Global.App_url
};
export const Reports_baocaotinhhinhgiamtscd = {
  id: BaoCao.BC42_BaoCaoTinhHinhGiamTSCD,
  text: 'Báo cáo tình hình giảm tài sản cố định',
  link: '/baocao/baocaotinhhinhgiamtscd/' + BaoCao.BC42_BaoCaoTinhHinhGiamTSCD,
  huongdan: Global.App_url
};

export const Reports_sotheodoitanggiamtscd = {
  id: BaoCao.BC42_BaoCaoTinhHinhGiamTSCD,
  text: 'Báo cáo tình hình tăng giảm TSCĐ (B04-H)',
  link: '/baocao/sotheodoitanggiamtscd/79FF2039-DCA6-4257-926D-EF609FC071CB',
  huongdan: Global.App_url
};

export const Reports_bienbankiemketscd = {
  id: BaoCao.BC43_BienBanKiemKeTSCD,
  text: 'Biên bản kiểm kê tài sản cố định',
  link: '/baocao/bienbankiemketscd/' + BaoCao.BC43_BienBanKiemKeTSCD,
  huongdan: Global.App_url
};

export const Reports_bienbankiemkeccdc = {
  id: BaoCao.BC43_BienBanKiemKeCCDC,
  text: 'Biên bản kiểm kê CCDC',
  link: '/baocao/bienbankiemkeccdc/' + BaoCao.BC43_BienBanKiemKeCCDC,
  huongdan: Global.App_url
};

export const Reports_baocaotaisan_c03_cctt = {
  id: BaoCao.BC43_BaoCaoTaiSanC03,
  text: 'Báo cáo tài sản mẫu C03/CCTT',
  link: '/baocao/baocaotaisanc03/' + BaoCao.BC43_BaoCaoTaiSanC03,
  huongdan: Global.App_url
};

export const Reports_danhsachtscdtheoloai = {
  id: BaoCao.BC44_DanhSachTSCDTheoLoai,
  text: 'Danh sách tài sản cố định theo loại',
  link: '/baocao/danhsachtscdtheoloai/' + BaoCao.BC44_DanhSachTSCDTheoLoai,
  huongdan: Global.App_url
};
export const Reports_soghigiamtscd = {
  id: BaoCao.BC45_SoGhiGiamTSCD,
  text: 'Sổ ghi giảm tài sản cố định',
  link: '/baocao/soghigiamtscd/' + BaoCao.BC45_SoGhiGiamTSCD,
  huongdan: Global.App_url
};
export const Reports_soghitangtscd = {
  id: BaoCao.BC46_SoGhiTangTSCD,
  text: 'Sổ ghi tăng tài sản cố định',
  link: '/baocao/soghitangtscd/' + BaoCao.BC46_SoGhiTangTSCD,
  huongdan: Global.App_url
};
export const Reports_baocaotonkho = {
  id: BaoCao.BC47_BaoCaoTonKho,
  text: 'Báo cáo tồn kho',
  link: '/baocao/baocaotonkho/' + BaoCao.BC47_BaoCaoTonKho,
  huongdan: Global.App_url
};
export const Reports_sotheodoicongcudungcu = {
  id: BaoCao.BC48_SoTheoDoiCongCuDungCu,
  text: 'Sổ theo dõi công cụ dụng cụ',
  link: '/baocao/sotheodoicongcudungcu/' + BaoCao.BC48_SoTheoDoiCongCuDungCu,
  huongdan: Global.App_url
};

export const Reports_sotheodoitanggiamccdc = {
  id: BaoCao.BC48_SoTheoDoiCongCuDungCu,
  text: 'Báo cáo tình hình tăng giảm công cụ, dụng cụ',
  link: '/baocao/sotheodoitanggiamccdc/C83A7638-6E95-4FD1-9635-3753F4FC9065',
  huongdan: Global.App_url
};


export const Reports_tokhaikhautruthuetncn = {
  id: BaoCao.BC49_ToKhaiThueTNCN,
  text: 'Tờ khai khấu trừ thuế thu nhập cá nhân (02KK-TNCN)',
  link: '/baocao/tokhaikhautruthuetncn/' + BaoCao.BC49_ToKhaiThueTNCN,
  huongdan: Global.App_url
};
export const Reports_tokhaiquyettoantncn = {
  id: BaoCao.BC50_ToKhaiQuyetToanTNCN,
  text: 'Tờ khai quyết toán thuế thu nhập cá nhân (05KK-TNCN)',
  link: '/baocao/tokhaiquyettoantncn/' + BaoCao.BC50_ToKhaiQuyetToanTNCN,
  huongdan: Global.App_url
};
export const Reports_tokhaiquyettoantncn_05qtt = {
  id: BaoCao.BC50_ToKhaiQuyetToanTNCN_05QTT,
  text: 'Tờ khai quyết toán thuế thu nhập cá nhân (05/QTT-TNCN)',
  link: '/baocao/tokhaiquyettoantncn05qtt/' + BaoCao.BC50_ToKhaiQuyetToanTNCN_05QTT,
  huongdan: Global.App_url
};
export const Reports_phuluctokhaiquyettoantncn = {
  id: BaoCao.BC51_PhuLucToKhaiQuyetToanTNCN,
  text: 'Phụ lục tờ khai quyết toán thuế thu nhập cá nhân (05-1/BK-TNCN)',
  link: '/baocao/phuluctokhaiquyettoantncn/' + BaoCao.BC51_PhuLucToKhaiQuyetToanTNCN,
  huongdan: Global.App_url
};
export const Reports_sotheodoitamung = {
  id: BaoCao.BC52_SoTheoDoiTamUng,
  text: 'Sổ theo dõi tạm ứng',
  link: '/baocao/sotheodoitamung/' + BaoCao.BC52_SoTheoDoiTamUng,
  huongdan: Global.App_url
};
export const Reports_giaydenghithanhtoantamung_c42bb = {
  id: BaoCao.BC52_01_C42BB_GiayDeNghiThanhToanTamUng,
  text: 'C42-BB: Giấy đề nghị thanh toán tạm ứng',
  link: '/baocao/giaydenghithanhtoantamung_c42bb/' + BaoCao.BC52_01_C42BB_GiayDeNghiThanhToanTamUng,
  huongdan: Global.App_url
};
export const Reports_bangintonghoptaikhoan = {
  id: BaoCao.BC53_BangInTongHopCuaTaiKhoan,
  text: 'Bảng in tổng hợp của tài khoản',
  link: '/baocao/bangintonghoptaikhoan/' + BaoCao.BC53_BangInTongHopCuaTaiKhoan,
  huongdan: Global.App_url
};
export const Reports_hachtoantaichinhvahachtoanngoaibang = {
  id: BaoCao.BC54_BaoCaoDoiChieuHachToanTaiChinhVaHachToanNgoaiBang,
  text: 'Báo cáo đối chiếu hạch toán tài chính và hạch toán ngoại bảng',
  link: '/baocao/hachtoantaichinhvahachtoanngoaibang/' + BaoCao.BC54_BaoCaoDoiChieuHachToanTaiChinhVaHachToanNgoaiBang,
  huongdan: Global.App_url
};
export const Reports_doichieukinhphirutvachimlns = {
  id: BaoCao.BC55_BaoCaoDoiChieuRutVaChiTheoMLNS,
  text: 'Báo cáo đối chiếu kinh phí rút và chi theo MLNS',
  link: '/baocao/doichieukinhphirutvachimlns/' + BaoCao.BC55_BaoCaoDoiChieuRutVaChiTheoMLNS,
  huongdan: Global.App_url
};
export const Reports_soducacchitietcuamottaikhoan = {
  id: BaoCao.BC56_BaoCaoSoDuCacChiTietCuaMotTaiKhoan,
  text: 'Báo cáo số dư các chi tiết của một tài khoản',
  link: '/baocao/soducacchitietcuamottaikhoan/' + BaoCao.BC56_BaoCaoSoDuCacChiTietCuaMotTaiKhoan,
  huongdan: Global.App_url
};
export const Reports_tonghopcongno = {
  id: BaoCao.BC57_TongHopCongNo,
  text: 'Báo cáo tổng hợp công nợ',
  link: '/baocao/tonghopcongno/' + BaoCao.BC57_TongHopCongNo,
  huongdan: Global.App_url
};
export const Reports_sotheodoichuyenkhoan = {
  id: BaoCao.BC58_SoTheoDoiChuyenKhoan,
  text: 'Sổ theo dõi chuyển khoản',
  link: '/baocao/sotheodoichuyenkhoan/' + BaoCao.BC58_SoTheoDoiChuyenKhoan,
  huongdan: Global.App_url
};
export const Reports_chungtuchuasinhhachtoandongthoi = {
  id: BaoCao.BC59_DanhSachChungTuChuaSinhHachToanDongThoi,
  text: 'Danh sách chứng từ chưa sinh hạch toán đồng thời',
  link: '/baocao/chungtuchuasinhhachtoandongthoi/' + BaoCao.BC59_DanhSachChungTuChuaSinhHachToanDongThoi,
  huongdan: Global.App_url
};
export const Reports_thongkechungtuketoan = {
  id: BaoCao.BC60_ThongKeChungTuKeToan,
  text: 'Thống kê chứng từ kế toán',
  link: '/baocao/thongkechungtuketoan/' + BaoCao.BC60_ThongKeChungTuKeToan,
  huongdan: Global.App_url
};
export const Reports_thongkechungtutonghop = {
  id: BaoCao.BC60_ThongKeChungTuKeToan,
  text: 'Thống kê chứng từ tổng hợp',
  link: '/baocao/thongkechungtutonghop/' + BaoCao.BC60_ThongKeChungTuKeToan,
  huongdan: Global.App_url
};

export const Reports_baocaokiemtrasosach = {
  id: BaoCao.BC208_BaoCaoKiemTraLoi,
  text: 'Báo cáo kiểm tra chứng từ, sổ sách',
  link: '/baocao/baocaokiemtrasosach/3BD20B3B-3CB7-4EA2-B19C-316AEDC13F2B',
  huongdan: Global.App_url
};


export const Reports_tonghopkinhphidasungdung= {
  id: BaoCao.BC61_TongHopKinhPhiDaSuDungDeNghiGhiThuGhiChi,
  text: 'Tổng hợp kinh phí đã sử dụng đề nghị ghi thu, ghi chi',
  link: '/baocao/tonghopkinhphidasungdung/' + BaoCao.BC61_TongHopKinhPhiDaSuDungDeNghiGhiThuGhiChi,
  huongdan: Global.App_url
};
export const Reports_baocaotinhhinhtaichinh = {
  id: BaoCao.BC63_BaoCaoTinhHinhTaiChinh,
  text: 'Báo cáo tình hình tài chính (B01/BCTC)',
  link: '/baocao/baocaotinhhinhtaichinh/' + BaoCao.BC63_BaoCaoTinhHinhTaiChinh,
  huongdan: Global.App_url
};
export const Reports_baocaoketquahoatdong = {
  id: BaoCao.BC64_BaoCaoKetQuaHoatDong,
  text: 'Báo cáo kết quả hoạt động (B02/BCTC)',
  link: '/baocao/baocaoketquahoatdong/' + BaoCao.BC64_BaoCaoKetQuaHoatDong,
  huongdan: Global.App_url
};
export const Reports_luuchuyentientetructiep = {
  id: BaoCao.BC65_BaoCaoLuuChuyenTienTe_TrucTiep,
  text: 'Báo cáo lưu chuyển tiền tệ (B03a/BCTC - TT107, TT24)',
  link: '/baocao/luuchuyentientetructiep/' + BaoCao.BC65_BaoCaoLuuChuyenTienTe_TrucTiep,
  huongdan: Global.App_url
};
export const Reports_luuchuyentientegiantiep = {
  id: BaoCao.BC66_BaoCaoLuuChuyenTienTe_GianTiep,
  text: 'Báo cáo lưu chuyển tiền tệ (theo phương pháp gián tiếp B03b/BCTC)',
  link: '/baocao/luuchuyentientegiantiep/' + BaoCao.BC66_BaoCaoLuuChuyenTienTe_GianTiep,
  huongdan: Global.App_url
};
export const Reports_baocaotaichinhb05 = {
  id: BaoCao.BC67_BaoCaoTaiChinhMauDonGian,
  text: 'Báo cáo tài chính (mẫu đơn giản B05/BCTC - TT107)',
  link: '/baocao/baocaotaichinhb05/' + BaoCao.BC67_BaoCaoTaiChinhMauDonGian,
  huongdan: Global.App_url
};

export const Reports_baocaotaichinhb05_24 = {
  id: BaoCao.BC65_BaoCaoLuuChuyenTienTe_TrucTiep,
  text: 'BC về những thay đổi trong TS thuần (B05/BCTC - TT24)',
  link: '/baocao/baocaotaichinhb05_24/' + BaoCao.BC67_BaoCaoVeNhungThayDoiTaiSanThuan,
  huongdan: Global.App_url
};

export const Reports_thuyetminhbaocaotaichinh = {
  id: BaoCao.BC68_ThuyetMinhBaoCaoTaiChinh,
  text: 'Thuyết minh báo cáo tài chính (B04/BCTC) ',
  link: '/baocao/thuyetminhbaocaotaichinh/' + BaoCao.BC68_ThuyetMinhBaoCaoTaiChinh,
  huongdan: Global.App_url
};
export const Reports_baocaobosungthongtintaichinh = {
  id: BaoCao.BC68_BSTT_BoSungThongTinTaiChinh,
  text: 'Báo cáo bổ sung thông tin tài chính (B01/BSTT) - TT99',
  link: '/baocao/baocaobosungthongtintaichinh/' + BaoCao.BC68_BSTT_BoSungThongTinTaiChinh,
  huongdan: Global.App_url
};
export const Reports_baocaotaichinhhopnhat = {
  id: BaoCao.BC69_BaoCaoTaiChinhHopNhat,
  text: 'Báo cáo tình tài chính hợp nhất',
  link: '/baocao/baocaotaichinhhopnhat/' + BaoCao.BC69_BaoCaoTaiChinhHopNhat,
  huongdan: Global.App_url
};
export const Reports_baocaobosungthongtinhopnhat = {
  id: BaoCao.BC69_BSTT_BaoCaoBoSungThongTinHopNhat,
  text: 'Báo cáo bổ sung thông tin tài chính hợp nhất (B01/BSTT)',
  link: '/baocao/baocaobosungthongtinhopnhat/' + BaoCao.BC69_BSTT_BaoCaoBoSungThongTinHopNhat,
  huongdan: Global.App_url
};
export const Reports_baocaoketquahoatdonghopnhat = {
  id: BaoCao.BC70_BaoCaoKetQuaHoatDongHopNhat,
  text: 'Báo cáo kết quả hoạt động hợp nhất',
  link: '/baocao/baocaoketquahoatdonghopnhat/' + BaoCao.BC70_BaoCaoKetQuaHoatDongHopNhat,
  huongdan: Global.App_url
};
export const Reports_baocaoluuchuyentientehopnhat = {
  id: BaoCao.BC71_BaoCaoLuuChuyenTienTeHopNhat,
  text: 'Báo cáo lưu chuyển tiền tệ hợp nhất',
  link: '/baocao/baocaoluuchuyentientehopnhat/' + BaoCao.BC71_BaoCaoLuuChuyenTienTeHopNhat,
  huongdan: Global.App_url
};
export const Reports_tonghopcongnohopnhat = {
  id: BaoCao.BC72_BaoCaoTongHopCongNoHopNhat,
  text: 'Báo cáo tổng hợp công nợ hợp nhất',
  link: '/baocao/tonghopcongnohopnhat/' + BaoCao.BC72_BaoCaoTongHopCongNoHopNhat,
  huongdan: Global.App_url
};
export const Reports_sotheodoichuyenkhoanhopnhat = {
  id: BaoCao.BC73_SoTheoDoiChuyenKhoanHopNhat,
  text: 'Sổ theo dõi chuyển khoản hợp nhất',
  link: '/baocao/sotheodoichuyenkhoanhopnhat/' + BaoCao.BC73_SoTheoDoiChuyenKhoanHopNhat,
  huongdan: Global.App_url
};
export const Reports_thongkechungtuketoanhopnhat= {
  id: BaoCao.BC74_ThongKeChungTuKeToanHopNhat,
  text: 'Thống kê chứng từ kế toán  hợp nhất',
  link: '/baocao/thongkechungtuketoanhopnhat/' + BaoCao.BC74_ThongKeChungTuKeToanHopNhat,
  huongdan: Global.App_url
};
export const Reports_bangtheodoithuchihopnhat = {
  id: BaoCao.BC75_BangTheoDoiThuChiHopNhat,
  text: 'Bảng theo dõi thu chi hợp nhất',
  link: '/baocao/bangtheodoithuchihopnhat/' + BaoCao.BC75_BangTheoDoiThuChiHopNhat,
  huongdan: Global.App_url
};
export const Reports_bangintonghopcuataikhoanhopnhat = {
  id: BaoCao.BC76_BangInTongHopCuaTaiKhoanHopNhat,
  text: 'Bảng in tổng hợp của tài khoản hợp nhất',
  link: '/baocao/bangintonghopcuataikhoanhopnhat/' + BaoCao.BC76_BangInTongHopCuaTaiKhoanHopNhat,
  huongdan: Global.App_url
};


export const Reports_sotheodoins_s104_p1 = {
  id: '338568E3-0F2A-4DE5-9ACA-6189F9EB21BA',
  text: 'S104-H: Sổ theo dõi kinh phí NSNN cấp bằng tiền (Phần I)',
  link: '/baocao/sotheodoins_s104_p1/338568E3-0F2A-4DE5-9ACA-6189F9EB21BA',
  huongdan: Global.App_url
};
export const Reports_sotheodoins_s104_p2 = {
  id: '98EBA501-2353-4FC3-AF20-B39D3FFEF957',
  text: 'S104-H: Sổ theo dõi kinh phí NSNN cấp bằng tiền (Phần II)',
  link: '/baocao/sotheodoins_s104_p2/98EBA501-2353-4FC3-AF20-B39D3FFEF957',
  huongdan: Global.App_url
};

export const Reports_sotheodoins_s105_p1 = {
  id: '03566EFA-C1F3-4A08-9A5F-C691B075A65E',
  text: 'S105-H: Sổ theo dõi kinh phí từ phí được khấu trừ, để lại (Phần I)',
  link: '/baocao/sotheodoins_s105_p1/03566EFA-C1F3-4A08-9A5F-C691B075A65E',
  huongdan: Global.App_url
};
export const Reports_sotheodoins_s105_p2 = {
  id: '8ACE2B0F-EA48-4605-A56B-B75EE1EAE070',
  text: 'S105-H: Sổ theo dõi kinh phí từ phí được khấu trừ, để lại (Phần II)',
  link: '/baocao/sotheodoins_s105_p2/8ACE2B0F-EA48-4605-A56B-B75EE1EAE070',
  huongdan: Global.App_url
};
export const Reports_sotheodoins_s105_p3 = {
  id: 'A9931D45-0D29-4923-90F6-0243DB89E16B',
  text: 'S105-H: Sổ theo dõi kinh phí từ phí được khấu trừ, để lại (Phần III)',
  link: '/baocao/sotheodoins_s105_p3/A9931D45-0D29-4923-90F6-0243DB89E16B',
  huongdan: Global.App_url
};


export const Reports_sotheodoidutoannsnnphan1 = {
  id: BaoCao.BC77_SoTheoDoiDuToanTuNSNN_Phan1,
  text: 'S101-H: Sổ theo dõi dự toán từ nguồn NSNN trong nước (Phần I)',
  link: '/baocao/sotheodoidutoannsnnphan1/' + BaoCao.BC77_SoTheoDoiDuToanTuNSNN_Phan1,
  huongdan: Global.App_url
};
export const Reports_sotheodoidutoannsnnphan2 = {
  id: BaoCao.BC78_SoTheoDoiDuToanTuNSNN_Phan2,
  text: 'S101-H: Sổ theo dõi dự toán từ nguồn NSNN trong nước (Phần II)',
  link: '/baocao/sotheodoidutoannsnnphan2/' + BaoCao.BC78_SoTheoDoiDuToanTuNSNN_Phan2,
  huongdan: Global.App_url
};
export const Reports_sotheodoidutoannsnnphan3 = {
  id: BaoCao.BC79_SoTheoDoiDuToanTuNSNN_Phan3,
  text: 'S101-H: Sổ theo dõi dự toán từ nguồn NSNN trong nước (Phần III)',
  link: '/baocao/sotheodoidutoannsnnphan3/' + BaoCao.BC79_SoTheoDoiDuToanTuNSNN_Phan3,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonvientrrophan2 = {
  id: BaoCao.BC80_SoTheoDoiNguonVienTro_Phan2,
  text: 'S102-H: Sổ theo dõi nguồn viện trợ (phần II)',
  link: '/baocao/sotheodoinguonvientrrophan2/' + BaoCao.BC80_SoTheoDoiNguonVienTro_Phan2,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonvaynophan1 = {
  id: BaoCao.BC81_SoTheoDoiNguonVayNoNuocNgoai_Phan1,
  text: 'S103-H: Sổ theo dõi nguồn vay nợ nước ngoài (phần I)',
  link: '/baocao/sotheodoinguonvaynophan1/' + BaoCao.BC81_SoTheoDoiNguonVayNoNuocNgoai_Phan1,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonvaynophan2 = {
  id: BaoCao.BC82_SoTheoDoiNguonVayNoNuocNgoai_Phan2,
  text: 'S103-H: Sổ theo dõi nguồn vay nợ nước ngoài (phần II)',
  link: '/baocao/sotheodoinguonvaynophan2/' + BaoCao.BC82_SoTheoDoiNguonVayNoNuocNgoai_Phan2,
  huongdan: Global.App_url
};
export const Reports_sotheodoikinhphinsnncapbanglenhchitien = {
  id: BaoCao.BC83_SoTheoDoiKinhPhiNSNNCapBangLenhChiTien,
  text: 'S104-H: Sổ theo dõi kinh phí NSNN cấp bằng lệnh chi tiền',
  link: '/baocao/sotheodoikinhphinsnncapbanglenhchitien/' + BaoCao.BC83_SoTheoDoiKinhPhiNSNNCapBangLenhChiTien,
  huongdan: Global.App_url
};
export const Reports_sotheodoiphiduockhautrudelai1 = {
  id: BaoCao.BC84_SoTheoDoiPhiDuocKhauTruDeLai_Phan1,
  text: 'S105-H: Sổ theo dõi nguồn phí được khấu trừ, để lại (Phần I)',
  link: '/baocao/sotheodoiphiduockhautrudelai1/' + BaoCao.BC84_SoTheoDoiPhiDuocKhauTruDeLai_Phan1,
  huongdan: Global.App_url
};
export const Reports_sotheodoiphiduockhautrudelai2 = {
  id: BaoCao.BC85_SoTheoDoiPhiDuocKhauTruDeLai_Phan2,
  text: 'S105-H: Sổ theo dõi nguồn phí được khấu trừ, để lại (Phần II)',
  link: '/baocao/sotheodoiphiduockhautrudelai2/' + BaoCao.BC85_SoTheoDoiPhiDuocKhauTruDeLai_Phan2,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonthuhoatdongkhacdelai1 = {
  id: BaoCao.BC86_SoTheoDoiNguonThuKhacDeLai_P1,
  text: 'S106-H: Sổ theo dõi nguồn thu hoạt động khác được để lại (Phần I)',
  link: '/baocao/sotheodoinguonthuhoatdongkhacdelai1/' + BaoCao.BC86_SoTheoDoiNguonThuKhacDeLai_P1,
  huongdan: Global.App_url
};
export const Reports_sotheodoinguonthuhoatdongkhacdelai2 = {
  id: BaoCao.BC87_SoTheoDoiNguonThuKhacDeLai_P2,
  text: 'S106-H: Sổ theo dõi nguồn thu hoạt động khác được để lại (Phần II)',
  link: '/baocao/sotheodoinguonthuhoatdongkhacdelai2/' + BaoCao.BC87_SoTheoDoiNguonThuKhacDeLai_P2,
  huongdan: Global.App_url
};
export const Reports_sochitietcackhoantamthu = {
  id: BaoCao.BC88_SoChiTietCacKhoanTamThu,
  text: 'Sổ chi tiết các khoản tạm thu (S52-H)',
  link: '/baocao/sochitietcackhoantamthu/' + BaoCao.BC88_SoChiTietCacKhoanTamThu,
  huongdan: Global.App_url
};
export const Reports_bangkechungtuthanhtoan = {
  id: BaoCao.BC89_BangKeChungTuThanhToan,
  text: 'Bảng kê chứng từ thanh toán (TT 161/2012/TT-BTC)',
  link: '/baocao/bangkechungtuthanhtoan/' + BaoCao.BC89_BangKeChungTuThanhToan,
  huongdan: Global.App_url
};
export const Reports_bangkechungtuthucchitamung = {
  id: BaoCao.BC90_BangKeChungTuThucChiTamUng,
  text: 'Bảng kê chứng từ thực chi/tạm ứng',
  link: '/baocao/bangkechungtuthucchitamung/' + BaoCao.BC90_BangKeChungTuThucChiTamUng,
  huongdan: Global.App_url
};
export const Reports_baocaothuchiencamketchi = {
  id: BaoCao.BC91_BaoCaoThucHienCamKetChi,
  text: 'Báo cáo thực hiện cam kết chi',
  link: '/baocao/baocaothuchiencamketchi/' + BaoCao.BC91_BaoCaoThucHienCamKetChi,
  huongdan: Global.App_url
};
export const Reports_baocaoquyettoankinhphihoatdong = {
  id: BaoCao.BC92_BaoCaoQuyetToanKinhPhiHoatDong,
  text: 'B01/BCQT: Báo cáo quyết toán kinh phí hoạt động',
  link: '/baocao/baocaoquyettoankinhphihoatdong/' + BaoCao.BC92_BaoCaoQuyetToanKinhPhiHoatDong,
  huongdan: Global.App_url
};
export const Reports_bangxacnhanchenhlechthuchi_s90h = {
  id: BaoCao.BC92_BangXacNhanChenhLech_S90H,
  text: 'S90-H: Bảng xác định chênh lệch thu, chi/tiết kiệm chi từ KP được giao tự chủ',
  link: '/baocao/bangxacnhanchenhlechthuchi_s90h/' + BaoCao.BC92_BangXacNhanChenhLech_S90H,
  huongdan: Global.App_url
};


export const Reports_thuyetminhbaocaoquyettoan = {
  id: BaoCao.BC93_ThuyetMinhBaoCaoQuyetToan,
  text: 'B03/BCQT: Thuyết minh báo cáo quyết toán',
  link: '/baocao/thuyetminhbaocaoquyettoan/' + BaoCao.BC93_ThuyetMinhBaoCaoQuyetToan,
  huongdan: Global.App_url
};
export const Reports_baocaoquyettoanf01 = {
  id: BaoCao.BC94_BCQT_F01,
  text: 'F01-01/BCQT: Chi tiết nguồn NSNN và nguồn phí được khấu trừ, để lại',
  link: '/baocao/baocaoquyettoanf01/' + BaoCao.BC94_BCQT_F01,
  huongdan: Global.App_url
};
export const Reports_baocaoquyettoankinhphif0102 = {
  id: '54FAE83F-56B5-462A-83D1-17DB6F1F2501',
  text: 'F01-02/BCQT: Báo cáo chi tiết kinh phí chương trình, dự án - Phần I',
  link: '/baocao/baocaoquyettoankinhphif0102/54FAE83F-56B5-462A-83D1-17DB6F1F2501',
  huongdan: Global.App_url
};
export const Reports_baocaoquyettoanf0102 = {
  id: BaoCao.BC95_BCQT_F01_02,
  text: 'F01-02/BCQT: Báo cáo chi tiết kinh phí chương trình, dự án - Phần II',
  link: '/baocao/baocaoquyettoanf0102/' + BaoCao.BC95_BCQT_F01_02,
  huongdan: Global.App_url
};
export const Reports_baocaoquyettoankinhphihoatdong_cauhinh = {
  id: BaoCao.BC92_BaoCaoQuyetToanKinhPhiHoatDong,
  text: 'Cấu hình B01/BCQT: Báo cáo quyết toán kinh phí hoạt động',
  link: '/danhmuc/cauhinhbaocaoquyettoankinhphihoatdong',
  huongdan: Global.App_url
};

export const Reports_bangxacnhanchenhlechthuchis90h_cauhinh = {
  id: BaoCao.BC92_BangXacNhanChenhLech_S90H,
  text: 'Cấu hình S90-H: Bảng xác định chênh lệch thu, chi/tiết kiệm chi từ KP được giao tự chủ',
  link: '/danhmuc/cauhinhbaocao_s90h',
  huongdan: Global.App_url
};



export const Reports_baocaoquyettoankinhphihoatdonghopnhat = {
  id: BaoCao.BC104_BaoCaoQuyetToanKinhPhiHoatDong_HopNhat,
  text: 'B01/BCQT: Báo cáo quyết toán kinh phí hoạt động',
  link: '/baocao/baocaoquyettoankinhphihoatdonghopnhat/' + BaoCao.BC104_BaoCaoQuyetToanKinhPhiHoatDong_HopNhat,
  huongdan: Global.App_url
};

export const Reports_baocaoquyettoanf01hopnhat = {
  id: BaoCao.BC105_BCQT_F01_HopNhat,
  text: 'F01-01/BCQT: Chi tiết nguồn NSNN và nguồn phí được khấu trừ, để lại',
  link: '/baocao/baocaoquyettoanf01hopnhat/' + BaoCao.BC105_BCQT_F01_HopNhat,
  huongdan: Global.App_url
};


export const Reports = {
    id:'',
    text: 'Báo cáo',
    link: '/reports',
  icon: 'fa fas fa-chart-area',  
  submenu: [
    {
      id: '',
      text: 'Sổ kế toán',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          
            Reports_socaimuclucngansach
          , Reports_socaitaikhoan
          , Reports_sochitietkinhphi
          , Reports_sochitietphaithuphaitra
          , Reports_sonhatkychung
          , Reports_banglietkechungtuketoan
          , Reports_sotheodoitienmattiengui_ngoaite
          , Reports_socaitheonhomdoiung
          , Reports_sochitietcactaikhoan
          , Reports_sochitietdoanhthus51
          , Reports_sochitietphaithukinhphiduoccap
          , Reports_sotheodoinguonkinhphi  //-- ẩn đi ngày 06/03/2025, chị đức bảo ẩn
          , Reports_sochitietthanhtoanvoikh
          , Reports_sotonghoptaikhoan
          , Reports_bangcandoisophatsinh
          //t
          , Reports_sochitietsxkd

          //, Reports_bangtonghopchungtu
          //, Reports_nhatkysocai
          //, Reports_chungtughiso
          //, Reports_sodangkychungtughiso
          //, Reports_socaihinhthucchungtughiso

        ]
    }
    ,
    {
      id: '',
      text: 'Kho bạc',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_sotheodoidutoannsnnphan1
        , Reports_sotheodoidutoannsnnphan2
        , Reports_sotheodoidutoannsnnphan3
        //, Reports_sotheodoinguonvientrrophan2
        //, Reports_sotheodoinguonvaynophan1
        //, Reports_sotheodoinguonvaynophan2
        //, Reports_sotheodoikinhphinsnncapbanglenhchitien
        //, Reports_sotheodoiphiduockhautrudelai1
        //, Reports_sotheodoiphiduockhautrudelai2
        

        , Reports_sotheodoins_s104_p1
        , Reports_sotheodoins_s104_p2
        , Reports_sotheodoins_s105_p1
        , Reports_sotheodoins_s105_p2
        , Reports_sotheodoins_s105_p3

        , Reports_sotheodoinguonthuhoatdongkhacdelai1
        , Reports_sotheodoinguonthuhoatdongkhacdelai2

        //, Reports_sochitietcackhoantamthu
        //, Reports_bangkechungtuthanhtoan
        //, Reports_bangkechungtuthucchitamung
        //, Reports_baocaothuchiencamketchi

      ]
    },
    
    {
      id: '',
      text: 'Đối chiếu kho bạc',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [

         Reports_bangkedoichieudutoanns_mau26
        , Reports_bangkedoichieudutoanns_mau28
        , Reports_bangkedoichieudutoanns_mau27
        , Reports_bangkedoichieudutoanns_mau29
        //, Reports_bangkedoichieudutoanns_mau30
        //, Reports_bangkedoichieudutoanns_mau31
        , Reports_bangkedoichieudutoanns_mau32


        , Reports_bangkedoichieudutoanns
        , Reports_bangkedoichieusudungns
        , Reports_bangxacnhansodutaikhoantg
        , Reports_thuchienkinhphingansach
        
      ]
    },
    {
      id: '',
      text: 'Tiền mặt, tiền gửi',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_soquytienmat
        , Reports_soketoanchitiettienmat
        , Reports_sotienguinganhang
        , Reports_sotheodoitienmatngoaite_s13h
      ]
    }
    ,
    {
      id: '',
      text: 'Mua hàng',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        //  Reports_bangkemuahang
         Reports_danhsachctthanhtoan
        , Reports_sochitietcongnophaitra
        , Reports_sochitietcongnophaitrangoaite
        , Reports_sotonghopcongnophaitra
        , Reports_sotonghopcongnophaitrangoaite
      ]
    }
    , {
      id: '',
      text: 'Bán hàng',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
          Reports_sochitietdoanhthu
        , Reports_sochitietbanhang
        , Reports_sochitietcongnophaithu
        , Reports_sochitietcongnophaithungoaite
        , Reports_sonhatkybanhang
        , Reports_sotonghopcongnophaithu
        , Reports_sotonghopcongnophaithungoaite
      ]
    }
    ,
    {
      id: '',
      text: 'Tài sản cố định',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
          Reports_haomontscd
        , Reports_sotaisancodinh
        , Reports_chitiettscd
        , Reports_sotheodoitscd
        , Reports_kiemketscd
        , Reports_sotheodoitanggiamtscd
        , Reports_baocaotinhhinhgiamtscd
        , Reports_bienbankiemketscd
        , Reports_danhsachtscdtheoloai
        , Reports_soghigiamtscd
        , Reports_soghitangtscd
        , Reports_sotheodoicongcudungcu
        , Reports_sotheodoitanggiamccdc
        , Reports_bienbankiemkeccdc
        , Reports_baocaotaisan_c03_cctt
        
      ]
    }
    
    ,
    {
      id: '',
      text: 'Báo cáo tài chính',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
         Reports_baocaotinhhinhtaichinh
        , Reports_baocaoketquahoatdong
        , Reports_luuchuyentientetructiep
        , Reports_luuchuyentientegiantiep
        , Reports_thuyetminhbaocaotaichinh
        , Reports_baocaotaichinhb05_24
        , Reports_baocaotaichinhb05
        , Reports_baocaobosungthongtintaichinh
      ]
    }
    ,
    {
      id: '',
      text: 'Báo cáo quyết toán',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
          Reports_baocaoquyettoankinhphihoatdong
        , Reports_baocaoquyettoanf01
        , Reports_thuyetminhbaocaoquyettoan

        , Reports_baocaoquyettoankinhphif0102
        , Reports_baocaoquyettoanf0102

        , Reports_bangxacnhanchenhlechthuchi_s90h
        , Reports_baocaoquyettoankinhphihoatdong_cauhinh
        , Reports_bangxacnhanchenhlechthuchis90h_cauhinh
       
      ]
    }
    ,
    {
      id: '',
      text: 'Báo cáo khác',
      link: '/elements',
      icon: 'fa fa-list-ul', 
      submenu: [
          Reports_sotheodoitamung
         , Reports_giaydenghithanhtoantamung_c42bb
         , Reports_bangintonghoptaikhoan
         , Reports_hachtoantaichinhvahachtoanngoaibang
         , Reports_doichieukinhphirutvachimlns
         , Reports_soducacchitietcuamottaikhoan
         , Reports_tonghopcongno
        , Reports_sotheodoichuyenkhoan
       // , Reports_chungtuchuasinhhachtoandongthoi
        , Reports_thongkechungtuketoan
        , Reports_thongkechungtutonghop
        , Reports_baocaokiemtrasosach
        , Reports_tonghopkinhphidasungdung
         , Reports_baocaotonkho
      ]
    }
    , {
      id: '',
      text: 'Báo cáo hợp nhất',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_bangcandoisophatsinh_tc
         ,Reports_baocaotaichinhhopnhat
        , Reports_baocaoketquahoatdonghopnhat
        , Reports_baocaoluuchuyentientehopnhat
        , Reports_tonghopcongnohopnhat
        , Reports_sotheodoichuyenkhoanhopnhat
        , Reports_thongkechungtuketoanhopnhat
        , Reports_bangtheodoithuchihopnhat
        , Reports_bangintonghopcuataikhoanhopnhat
        , Reports_baocaoquyettoankinhphihoatdonghopnhat
        , Reports_baocaoquyettoanf01hopnhat
        , Reports_baocaobosungthongtinhopnhat
      ]
    }
    ,
    {
      id: '',
      text: 'Tiền lương',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_tokhaikhautruthuetncn
        , Reports_tokhaiquyettoantncn_05qtt
        //, Reports_tokhaiquyettoantncn
        , Reports_phuluctokhaiquyettoantncn


      ]
    }
    , Reports_dshoadon, Reports_doanhthu
    , Reports_nhapxuat
    , Reports_hoahong
    , Reports_ketquakinhdoanh]
};
//--------------------danh mục
export const Lists_nguonkinhphi = {
    id: '9840B305-82FD-4EB9-B275-5ED4B58F8282',
    text: 'Nguồn kinh phí',
  link: '/danhmuc/nguonkinhphi',
  visible:true,
  huongdan: Global.App_url
};

export const Lists_chuong = {
    id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
    text: 'Chương',
  link: '/danhmuc/chuong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaikhoan = {
    id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
    text: 'Loại khoản',
  link: '/danhmuc/loaikhoan',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_tieumuc = {
    id: '5E79BF59-78D9-4C54-8EF7-0A242F5CBC24',
    text: 'Tiểu mục',
  link: '/danhmuc/tieumuc',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_canbo = {
    id: '9B6F13B5-88F8-4CF1-90CF-DAE04C849B26',
    text: 'Cán bộ',
  link: '/danhmuc/canbo',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_khachhang = {
    id: '2CEA2A10-9E2A-4EDF-969A-B4DFBE99C48A',
    text: 'Khách hàng',
  link: '/danhmuc/khachhang',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhacungcap = {
    id: 'DE964E8B-BE82-417F-A7DF-2CFB240E8E44',
    text: 'Nhà cung cấp',
  link: '/danhmuc/nhacungcap',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_caphat = {
  id: 'D02C046F-FADD-42E4-B0E1-C78663076640',
    text: 'Hình thức cấp phát',
  link: '/danhmuc/hinhthuccapphat',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nghiepvu = {
  id: 'ABD85401-87F6-4EB8-BD26-2A9713DF53D8',
  text: 'Nghiệp vụ',
  link: '/danhmuc/nghiepvu',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loai_nganhang = {
  id: 'C4BF3734-6CA4-4491-9A2C-A6971D28FFE9',
  text: 'Loại tài khoản NH, KB',
  link: '/danhmuc/loaitknganhangkhobac',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nganhang = {
  id: '4316191F-5C48-413C-82B3-DFD870C0FAFE',
  text: 'Tài khoản ngân hàng, KBNN',
  link: '/danhmuc/nganhang',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_doituong = {
  id: '532A61EA-D765-844B-8CBF-E610B209E332',
  text: 'Đối tượng thống kê',
  link: '/danhmuc/doituongthongke',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_doituongtaphop = {
  id: '8F3FBD94-4461-4C6E-AA5A-E25A440CAA7F',
  text: 'Đối tượng tập hợp',
  link: '/danhmuc/doituongtaphop',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_doituongtaphop2 = {
  id: 'F40B0AAC-6CC2-43C6-99FA-65D6C8AFE572',
  text: 'Đối tượng tập hợp 2',
  link: '/danhmuc/doituongtaphop2',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_hoatdong = {
  id: 'A2E1B866-FE5D-4013-B65F-60DFA1A14620',
  text: 'Hoạt động',
  link: '/danhmuc/hoatdong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhomctmt = {
  id: '0D50CE9D-A352-4842-BDA1-930410C8A98C',
  text: 'Nhóm CTMT, dự án',
  link: '/danhmuc/nhomctmt',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_cmmt = {
  id: '9C0B41B7-CA5D-494C-9D17-877FDA70E1FF',
  text: 'CTMT, dự án',
  link: '/danhmuc/cmmt',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_mathongke = {
  id: '2F6B699E-3843-43E7-B2D6-ADCB7C790B40',
  text: 'Mã thống kê',
  link: '/danhmuc/mathongke',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhommucchi = {
  id: 'C984553F-B0E6-454D-BE82-5AB776E76763',
  text: 'Nhóm mục chi',
  link: '/danhmuc/nhommucchi',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhiemvuchi = {
  id: '73F13C3A-1C1A-466E-96C5-A20E79F0105D',
  text: 'Nhiệm vụ chi',
  link: '/danhmuc/nhiemvuchi',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhomvattuhanghoa = {
  id: 'FE2C6389-6483-40E4-BEEB-D699D9164D88',
  text: 'Nhóm vật tư, hàng hóa',
  link: '/danhmuc/nhomvattuhanghoa',
  visible: true,
  huongdan: Global.App_url
};  
export const Lists_vattuhanghoa = {
  id: 'B8A00ED6-8EA0-462B-B1D0-D41466880EFB',
  text: 'Vật tư, hàng hóa',
  link: '/danhmuc/vattuhanghoa',
  visible: true,
  huongdan: Global.App_url
};  
export const Lists_taisancodinh = {
  id: '5A44C760-BA5C-4D6C-84A7-D9A5BA8D7B60',
  text: 'Tài sản cố định',
  link: '/danhmuc/taisancodinh',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_congcudungcu = {
  id: '13AD5FED-19D5-4DB7-A40A-9489E636B0AF',
  text: 'Công cụ dụng cụ',
  link: '/danhmuc/congcudungcu',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_donvitinh = {
  id: 'F00AAC21-AA52-4BF5-809D-82C90674BD22',
  text: 'Đơn vị tính',
  link: '/danhmuc/donvitinh',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_philephi = {
  id: '969C3ABE-7E49-48C0-8F9D-5AC907CA98FA',
  text: 'Phí, lệ phí',
  link: '/danhmuc/philephi',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaiquy = {
  id: '9F114162-D86A-4CDA-9C77-ACBCAE7BA775',
  text: 'Loại quỹ',
  link: '/danhmuc/loaiquy',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_manguonnsnn = {
  id: 'D8874958-FFEF-48E8-87F7-79494B385296',
  text: 'Mã nguồn NSNN',
  link: '/danhmuc/manguonnsnn',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_tinhchatnguonkp = {
  id: 'FAA93D1C-D129-4EC7-999F-9463593A4A55',
  text: 'Tính chất nguồn kinh phí',
  link: '/danhmuc/tinhchatnguonkp',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_phongban = {
  id: 'C83F032C-8834-44D8-94B5-D9E5A91D9A56',
  text: 'Phòng ban',
  link: '/danhmuc/phongban',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaitaisan = {
  id: '96A4CB47-2CCF-48FF-B49B-EC55DE24AFEF',
  text: 'Loại tài sản',
  link: '/danhmuc/loaitaisan',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaicongcu = {
  id: '320EE67F-7B39-4E6A-B544-2066CA6E727E',
  text: 'Loại công cụ',
  link: '/danhmuc/loaicongcu',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nguonhinhthanh = {
  id: '4D4563D4-4B0E-436B-A34D-D6CB8D6D6478',
  text: 'Nguồn hình thành',
  link: '/danhmuc/nguonhinhthanh',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_xuatxu = {
  id: 'DA8FF299-09A0-470D-9275-463536BCB810',
  text: 'Danh mục xuất xứ hàng hóa',
  link: '/danhmuc/xuatxu',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_taikhoanketchuyen = {
  id: 'A4036F30-612E-40BE-861D-E22F45CFDBCB',
  text: 'Danh mục tài khoản kết chuyển',
  link: '/danhmuc/taikhoanketchuyen',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_khohang = {
  id: '24AADC58-6F18-44B0-A1D3-DEDCF0BA2060',
  text: 'Kho hàng',
  link: '/danhmuc/khohang',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaitiente = {
  id: '0A153DF1-7E93-4EF6-A372-2E5F39E613E7',
  text: 'Loại tiền tệ',
  link: '/danhmuc/loaitiente',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaicanbo = {
  id: '4A625C2C-BBCF-4EE1-84B0-2BDC221201B7',
  text: 'Loại cán bộ',
  link: '/danhmuc/loaicanbo',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_ngachluong = {
  id: '6B6A7530-5978-4F65-ADFA-33345900CF7E',
  text: 'Ngạch lương',
  link: '/danhmuc/ngachluong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_khoanluong = {
  id: '540F55EE-0805-4524-AAF3-AA3C1CB43E64',
  text: 'Khoản lương',
  link: '/danhmuc/khoanluong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_taikhoan = {
  id: 'C1371682-A61F-4C16-A27E-68462B12D822',
  text: 'Tài khoản kế toán',
  link: '/danhmuc/taikhoan',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_hopdongmua = {
  id: '2E76671D-9E9D-45FF-9187-6C7E6192C859',
  text: 'Hợp đồng mua',
  link: '/danhmuc/hopdongmua',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_hopdongban = {
  id: '0BF2B218-3D3A-4E2A-906B-06E4A13F135B',
  text: 'Hợp đồng bán',
  link: '/danhmuc/hopdongban',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaitailieu = {
  id: '0AF84C3A-B45C-4047-94DE-9D1D8D506200',
  text: 'Loại tài liệu',
  link: '/danhmuc/loaitailieu',
  visible: true,
  huongdan: Global.App_url
};

export const DanhMucs = [Lists_nguonkinhphi, Lists_loaikhoan, Lists_tieumuc, Lists_caphat, Lists_nghiepvu, Lists_hoatdong, Lists_cmmt, Lists_nhiemvuchi,
  Lists_canbo, Lists_khachhang, Lists_nhacungcap, Lists_nganhang, Lists_vattuhanghoa, Lists_nhomvattuhanghoa
  , Lists_taisancodinh, Lists_congcudungcu, Lists_khohang, Lists_mathongke
]
export const Lists = {
    id:'',
    text: 'Danh mục',
    link: '/elements',
    icon: 'fa fa-list-ul',
  submenu: [
    {
      id: '',
      text: 'Mục lục ngân sách',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Lists_nguonkinhphi
        , Lists_chuong
        , Lists_loaikhoan

        , Lists_tieumuc
        , Lists_caphat
        , Lists_nghiepvu
        , Lists_hoatdong
        , Lists_cmmt
        , Lists_mathongke
        , Lists_nhommucchi
        , Lists_loai_nganhang
        , Lists_nhiemvuchi
        , Lists_tinhchatnguonkp
        , Lists_nhomctmt
      ]
    },
    {
      id: '',
      text: 'Đối tượng',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Lists_canbo
        , Lists_khachhang
        , Lists_nhacungcap
        , Lists_nganhang
        , Lists_doituong
        , Lists_doituongtaphop
        , Lists_doituongtaphop2
      ]
    }
    ,
    {
      id: '',
      text: 'Vật tư, tài sản',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
          Lists_vattuhanghoa
        , Lists_taisancodinh
        , Lists_congcudungcu
        , Lists_loaitaisan
        , Lists_loaicongcu
        , Lists_nguonhinhthanh
        , Lists_khohang
        , Lists_nhomvattuhanghoa
      ]
    }
    ,
    {
      id: '',
      text: 'Tổng hợp',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Lists_taikhoan
         , Lists_donvitinh
        , Lists_loaitiente
        , Lists_philephi
        , Lists_loaiquy
        , Lists_manguonnsnn
        , Lists_phongban
        , Lists_xuatxu
        , Lists_loaicanbo
        , Lists_ngachluong
        , Lists_taikhoanketchuyen
        //, Lists_xuatxu
       // , Lists_hopdongmua
       // , Lists_hopdongban
        //, Lists_loaitailieu
      ]
    }
   ]
    
};
//-------------------phân hệ quỹ
export const tiens_phieuthu = {
  id: 'C7CE86D5-2FF0-4BA5-9B93-DAA964D03B6B',
    text: 'Phiếu thu tiền mặt',
  link: '/ketoan/phieuthu',
  huongdan: Global.App_url
};
export const tiens_phieuchi = {
  id: 'A78618AD-EF7F-44E6-A6E2-201AF7B6E2DA',
    text: 'Phiếu chi tiền mặt',
  link: '/ketoan/phieuchi',
  huongdan: Global.App_url,
  border: 'Co'
};
export const tiens_baoco = {
  id: '6B4FF64A-8A34-4151-9FB2-D05E498FE3E8',
  text: 'Báo có',
  link: '/ketoan/baoco',
  huongdan: Global.App_url
};
export const tiens_baono = {
  id: 'A5C1EF47-FF01-4CB1-B4E2-A27E97310AA8',
  text: 'Báo nợ',
  link: '/ketoan/baono',
  huongdan: Global.App_url  
};
export const tiens_cknoibo = {
  id: '7AC8A5FF-FBB8-4C50-B4E0-0D885D152CD1',
  text: 'Chuyển tiền nội bộ',
  link: '/ketoan/chuyentiennoibo',
  huongdan: Global.App_url,
  border: ''
};
export const tiens_nhandutoan = {
  id: '6F194AD7-25B0-4BF4-8261-260F1DF3BA67',
  text: 'Nhận dự toán',
  link: '/ketoan/nhandutoan',
  huongdan: Global.App_url,
  border: 'Co'
};
export const tiens_dcdutoan = {
  id: 'E9B0DF8E-8495-40C9-932D-3A79BA300E19',
  text: 'Điều chỉnh dự toán',
  link: '/ketoan/dieuchinhdutoan',
  huongdan: Global.App_url
};
export const tiens_huydutoan = {
  id: '816C0251-3812-4172-8AAA-B996D11BA56A',
  text: 'Hủy dự toán',
  link: '/ketoan/huydutoan',
  huongdan: Global.App_url
};
export const tiens_giulaidutoan = {
  id: 'D937DA4D-2690-4744-801C-E89FD47F23EE',
  text: 'Dự toán giữ lại',
  link: '/ketoan/giulaidutoan',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_tienmat = {
  id: 'E43D452F-63CB-4944-9C39-51E630AC7B6A',
  text: 'Rút dự toán',
  link: '/ketoan/rutdutoan',
  huongdan: Global.App_url
};

export const tiens_rutdutoan_giaonhanhoso = {
  id: '7E5F8F28-182B-43B0-A3E7-F68F021DD887',
  text: 'Danh sách hồ sơ giao nhận',
  link: '/ketoan/giaonhanhoso',
  huongdan: Global.App_url
};

export const tiens_rutdutoan_giaonhanhosoktt = {
  id: '22D9C33F-7926-40AE-BCD2-EA489EF0E373',
  text: 'Danh sách hồ sơ giao nhận (kế toán trưởng)',
  link: '/ketoan/giaonhanhosoktt',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_giaonhanhosoctk = {
  id: '251A454C-B0FE-461A-AE37-55441381AACB',
  text: 'Danh sách hồ sơ giao nhận (Thủ trưởng đơn vị)',
  link: '/ketoan/giaonhanhosoctk',
  huongdan: Global.App_url
};


export const tiens_rutdutoan_nhapquy = {
  id: '2A22CAE5-C3D8-4BE1-83A6-C4BD62405F53',
  text: 'Phiếu thu rút dự toán',
  link: '/ketoan/rutdutoannhapquy',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_tiengui = {
  id: '1D73E368-E65B-410D-8D89-CAC8AA9E206E',
  text: 'Rút dự toán tiền gửi',
  link: '/ketoan/rutdutoantiengui',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_vaotk = {
  id: '1A8A5283-51B5-4934-8979-B478380F7A52',
  text: 'Báo có rút dự toán',
  link: '/ketoan/rutdutoanvaotk',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_ck = {
  id: '6EDD7C8F-8794-48BC-91BF-EDF4D8513226',
  text: 'Rút dự toán chuyển khoản',
  link: '/ketoan/rutdutoanchuyenkhoan',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_ck_ts = {
  id: '3911644E-D629-47ED-B2C6-5ED6124B45D8',
  text: 'Rút dự toán chuyển khoản mua tài sản',
  link: '/ketoan/rutdutoanchuyenkhoanmuats',
  huongdan: Global.App_url
};
export const tiens_rutdutoan_ctuck = {
  id: '046EBE47-3190-4046-9458-AA2AEF01F238',
  text: 'Chuyển khoản kho bạc',
  link: '/ketoan/chungtudutoanck',
  huongdan: Global.App_url
};
export const tiens_bangkethanhtoan = {
  id: '4E324687-5446-4366-A875-43C4B9D64CE6',
  text: 'Bảng kê thanh toán',
  link: '/ketoan/bangkethanhtoan',
  huongdan: Global.App_url,
  border: 'Co'
};
export const tiens_dieuchinhkinhphi = {
  id: '1F113807-E6AA-4751-9D2C-3DD7835A8DEA',
  text: 'Điều chỉnh kinh phí',
  link: '/ketoan/dieuchinhkinhphi',
  huongdan: Global.App_url,
  border: 'Co'
};
export const tiens_bangketamung = {
  id: 'E1F2BE54-ED8E-4696-87DA-2DE06F1F7A2F',
  text: 'Bảng kê tạm ứng',
  huongdan: Global.App_url,
  link: '/ketoan/bangketamung'
};
export const tiens_camketchi = {
  id: '287465B0-4707-411D-998B-B5B1E0F0621A',
  text: 'Cam kết chi',
  huongdan: Global.App_url,
  link: '/ketoan/camketchi'
};
export const tiens_dccamketchi = {
  id: '52C51CEE-A33B-405E-A8ED-4DCA1C3BBA15',
  text: 'Điều chỉnh cam kết chi',
  huongdan: Global.App_url,
  link: '/ketoan/dccamketchi'
};
export const tiens_camketchidauky = {
  id: 'DF1CF1CA-C1B8-4C3D-98D3-E44815C9AD56',
  text: 'Cam kết chi đầu kỳ',
  huongdan: Global.App_url,
  link: '/ketoan/camketchidauky'
};
export const tonghops_chungtukhac = {
  id: '2E5DD4FB-1DC0-4679-B0C1-424F93D0052A',
  text: 'Chứng từ tổng hợp',
  link: '/ketoan/chungtukhac',
  huongdan: Global.App_url
};
export const tonghops_chungtuketchuyen = {
  id: 'CE4F89FF-0A00-43D0-BADC-AAB6AB860E0E',
  text: 'Chứng từ kết chuyển',
  link: '/ketoan/chungtuketchuyen',
  huongdan: Global.App_url
};
export const tonghops_dudauky = {
  id: 'FFE5DC43-7EC9-46BB-A5AE-73BECA5F6537',
  text: 'Số dư đầu kỳ theo TT107',
  link: '/ketoan/sodudauky',
  huongdan: Global.App_url
};

export const tonghops_dudauky2025 = {
  id: 'FFE5DC43-7EC9-46BB-A5AE-73BECA5F6537',
  text: 'Số dư đầu kỳ',
  link: '/ketoan/sodudauky2025',
  huongdan: Global.App_url
};

export const tiens = {
  id:'',
    text: ' Chứng từ',
    link: '/',
  icon: 'fas fa-dollar-sign',
  submenu: [tiens_phieuthu, tiens_phieuchi, tiens_baoco, tiens_baono
    , tiens_cknoibo, tonghops_chungtukhac, tonghops_chungtuketchuyen
    //, tonghops_dudauky
    ,tonghops_dudauky2025
  ]
};
//------- ngân sách
export const KhoBacs = {
  id: '',
  text: ' Ngân sách',
  icon: 'fas fa-house-damage',
  submenu: [tiens_nhandutoan, tiens_rutdutoan_tienmat,
    tiens_rutdutoan_giaonhanhoso, tiens_rutdutoan_giaonhanhosoktt, tiens_rutdutoan_giaonhanhosoctk,
    tiens_rutdutoan_nhapquy, tiens_rutdutoan_vaotk, tiens_rutdutoan_ctuck, tiens_bangkethanhtoan, tiens_camketchi, tiens_dccamketchi, tiens_camketchidauky
  ]
};

//----------công cụ
export const congcus_soducongcudungcu = {
  id: '237B544D-D773-4F06-8D86-2D2C9498ACEE',
  text: 'Khai báo công cụ dụng cụ ban đầu',
  link: '/ketoan/congcudungcubandau',
  huongdan: Global.App_url
};
export const congcus_ghitang = {
  id: '8A54FE30-9E2C-4845-8ADD-D347E33F300D',
  text: 'Ghi tăng công cụ',
  link: '/ketoan/ghitangcongcu',
  huongdan: Global.App_url
};
export const congcus_ghigiam = {
  id: '70C529FA-3957-4470-8D03-C85FDFB4D977',
  text: 'Ghi giảm công cụ',
  link: '/ketoan/ghigiamcongcu',
  huongdan: Global.App_url
};
export const congcus_dieuchuyencongcu = {
  id: '4E5B8003-CF61-4FA1-8D80-12E0086EC169',
  text: 'Điều chuyển công cụ',
  link: '/ketoan/dieuchuyencongcu',
  huongdan: Global.App_url,
  border: 'co'
};
export const congcus_phanbo = {
  id: 'BBE6FD1C-CE59-48BD-95DC-C926E88103A2',
  text: 'Kết chuyển công cụ',
  link: '/ketoan/phanbocongcu',
  huongdan: Global.App_url,
  
};
export const congcus_cauhinh = {
  id: '2683A34A-D6EF-40A7-8B0E-98210A98B20E',
  text: 'Cấu hình công cụ',
  link: '/danhmuc/cauhinhcongcu',
  huongdan: Global.App_url,

};
export const congcus = {
  id: '',
  text: ' Công cụ',
  link: '/',
  icon: 'fas fa-dollar-sign',
  submenu: [
    congcus_ghitang, congcus_ghigiam
    , congcus_dieuchuyencongcu
    //, congcus_phanbo
    , congcus_soducongcudungcu
  ]
};
//-------------------tiện ích
export const Ultil_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Quản lý người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const Ultil_phanquyen = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Quản lý phân quyền',
  link: '/quantri/vaitro',
  huongdan: Global.App_url
};
export const Ultil_doimatkhau = {
  id: '',
  text: 'Đổi mật khẩu',
  link: '/quantri/doimatkhau',
  huongdan: Global.App_url
};
export const Ultil_cauhinhnhapdulieutuexcel = {
  id: '1EC79DE0-51D4-43EF-BF16-5C8E94CB1CD1',
  text: 'Cấu hình nhập dữ liệu từ excel',
  link: '/quantri/maubaocao',
  huongdan: Global.App_url
};



export const Ultil_bug = {
  id: '5159E97E-2428-4C72-999D-DE2F444B2D39',
  text: 'Quản lý test',
  link: '/quantri/bug',
  huongdan: Global.App_url
};
export const Ultil_nhatkytruycap = {
  id: '2391F2AB-836E-48E9-B8C0-BE1FC543E387',
  text: 'Nhật ký truy cập',
  link: '/quantri/nhatkytruycap',
  border:'co',
  huongdan: Global.App_url
};


export const Ultil_nhanvien = {
    id: 'EB568D2C-E77C-4DE5-9CAB-82359D2A13EB',
    text: 'Danh sách nhân viên',
  link: '/caidat/nhanvien',
  huongdan: Global.App_url
};
export const Ultil_hoahong = {
    id: '73ABA6E6-BF7B-496D-AC7D-F9E3FE241002',
    text: 'Hoa hồng nhân viên',
  link: '/caidat/hoahong',
  huongdan: Global.App_url
};

export const Ultil_khachhang = {
    id: '24A92939-9CEB-4DB6-BB4A-2C5379A3ED65',
    text: 'Quản lý khách hàng',
  link: '/caidat/khachhang',
  huongdan: Global.App_url
};
export const Ultil_soquy = {
    id: '8C7443C8-7A12-4903-B27D-66EEF0947B71',
    text: 'Sổ quỹ tiền mặt',
  link: '/caidat/soquy',
  huongdan: Global.App_url
};
export const Ultil_tinhgia = {
    id: '0A4BB264-56CA-4ADC-B851-0DAC63AECB6B',
    text: 'Tính giá vốn',
  link: '/caidat/tinhgiavon',
  huongdan: Global.App_url
};
export const Ultil_cauhinhdongthoi = {
  id: '155C1465-40AC-4D2A-B51E-B2BA1DFA0FA2',
  text: 'Cấu hình hạch toán đồng thời',
  link: '/ketoan/cauhinhdongthoi',
  huongdan: Global.App_url
};
export const Ultil_hachtoanquy = {
  id: '5A0B6C81-0811-466D-ACAA-E2841EF25988',
  text: 'Cấu hình hạch toán quỹ',
  link: '/danhmuc/hachtoanquy',
  huongdan: Global.App_url
};
export const Ultil_hachtoankhobac = {
  id: 'CED94EE4-A72E-4411-89F7-D46197DF4283',
  text: 'Cấu hình hạch toán kho bạc',
  link: '/danhmuc/hachtoankhobac',
  huongdan: Global.App_url
};
export const Ultil_hachtoantaisan = {
  id: 'FBB08A81-C1F7-47C2-85AA-37950C368F61',
  text: 'Cấu hình hạch toán tài sản',
  link: '/danhmuc/hachtoantaisan',
  huongdan: Global.App_url
};
export const Ultil_hachtoanmuahang = {
  id: '5B3EA275-DED9-462C-8185-B2E05DF2C1FE',
  text: 'Cấu hình hạch toán mua hàng',
  link: '/danhmuc/hachtoanmuahang',
  huongdan: Global.App_url
};
export const Ultil_hachtoanluong = {
  id: 'C1A16123-E644-4180-91A4-31EB2534AE25',
  text: 'Cấu hình hạch toán lương',
  link: '/danhmuc/hachtoanluong',
  border: 'co',
  huongdan: Global.App_url
};
export const Ultil_khoaso = {
  id: '2BB77568-1346-4056-9839-60B6D85F80FC',
  text: 'Khóa sổ kế toán',
  link: '/danhmuc/khoaso',
  huongdan: Global.App_url
};
export const Ultil_danhsochungtu = {
  id: '6E03C81C-C426-4C94-AE24-BA7E769B944F',
  text: 'Đánh số chứng từ',
  link: '/ketoan/danhsochungtu',
  huongdan: Global.App_url
};
export const Ultil_timdoituong = {
  id: '3E366F69-BDEE-4D73-963A-6DCAA2BC070B',
  text: 'Tìm đối tượng',
  link: '/ketoan/timdoituong',
  huongdan: Global.App_url
};
export const Ultil_kiemtraloi = {
  id: 'C641370B-520E-48CF-A95E-D58E82607D42',
  text: 'Kiểm tra lỗi thiếu đối tượng',
  link: '/ketoan/kiemtraloi',
  huongdan: Global.App_url
};
export const Ultil_tailieu = {
  id: '4034D0E4-356E-4CEB-9C1A-2DD64882807C',
  text: 'Quản lý tài liệu',
  link: '/quantri/quanlytailieu',
  huongdan: Global.App_url
};
export const Ultil_baocaotaichinh = {
  id: 'BBE052F1-7029-4626-806A-8C692C434A2C',
  text: 'Cấu hình báo cáo tình hình tài chính',
  link: '/danhmuc/cauhinhbaocaotaichinh',
  huongdan: Global.App_url
};
export const Ultil_baocaotaichinhmaudongia = {
  id: '5402F5FF-5BA5-4DD0-BB64-4628F659BC9C',
  text: 'Cấu hình báo cáo tài chính (mẫu đơn giản)',
  link: '/danhmuc/cauhinhbaocaotaichinhmaudongian',
  huongdan: Global.App_url
};
export const Ultil_baocaoketquahoatdong = {
  id: '21FF2E26-3486-4B36-BE1C-B3C87C40EEFE',
  text: 'Cấu hình báo cáo kết quả hoạt động',
  link: '/danhmuc/cauhinhbaocaoketquahoatdong',
  huongdan: Global.App_url
};

export const Ultil_baocaoluuchuyentientetructiep = {
  id: '1067D24D-DBA4-4B90-99CF-8115C152C5A4',
  text: 'Cấu hình báo cáo lưu chuyển tiền tệ (trực tiếp)',
  link: '/danhmuc/cauhinhbaocaoluuchuyentientetructiep',
  huongdan: Global.App_url
};
export const Ultil_baocaoluuchuyentientegiantiep = {
  id: 'E79E5743-E6B2-43C8-B25A-1C7574AEF596',
  text: 'Cấu hình báo cáo lưu chuyển tiền tệ (gián tiếp)',
  link: '/danhmuc/cauhinhbaocaoluuchuyentientegiantiep',
  huongdan: Global.App_url
};
export const Ultil_baocaothuyetminhtaichinh = {
  id: 'EDE794E0-B59D-454A-93C9-D3BEC39B9315',
  text: 'Cấu hình thuyết minh báo cáo tài chính (B04/BCTC)',
  link: '/danhmuc/cauhinhthuyetminhtaichinh',
  huongdan: Global.App_url
};

export const Ultil_baocaobosungthongtintaichinh = {
  id: 'D76B6D63-013A-4B0F-B6BB-5F9067E0A195',
  text: 'Cấu hình bổ sung thông tin tài chính (B01/BSTT)',
  link: '/danhmuc/cauhinhbosungthongtintaichinh',
  huongdan: Global.App_url
};

export const Ultil_baocaob05_bctc = {
  id: '8BFA2D86-CF11-4CCB-863E-51ADEDA233FC',
  text: 'Cấu hình BC những thay đổi trong TS thuần (B05/BCTC)',
  link: '/danhmuc/cauhinhb05_bctc',
  huongdan: Global.App_url
};

export const Ultil = {
    id:'',
    text: 'Tiện ích',
    link: '/headingComponents',
  icon: 'fa fas fa-th',
  submenu: [
    Ultil_timdoituong,
    Ultil_kiemtraloi,
    Ultil_danhsochungtu,
    Ultil_khoaso,
    //Ultil_tailieu,
    //Ultil_nhatkytruycap,
    Ultil_cauhinhnhapdulieutuexcel,
    Ultil_cauhinhdongthoi,
    Ultil_hachtoanquy,
    Ultil_hachtoankhobac,
    Ultil_hachtoantaisan,
    Ultil_hachtoanmuahang,
    Ultil_hachtoanluong,

    Ultil_baocaotaichinh,
    Ultil_baocaoketquahoatdong,
    Ultil_baocaoluuchuyentientetructiep,
    Ultil_baocaoluuchuyentientegiantiep,
    Ultil_baocaothuyetminhtaichinh,
    Ultil_baocaob05_bctc,
    Ultil_baocaotaichinhmaudongia,
    Ultil_baocaobosungthongtintaichinh
    
    ]
};

//------------------------bảng lương
export const payroll_bangcong = {
  id: '81BEFB36-CBE4-4AC0-8526-53F3F9BDD1E0',
  text: 'Bảng công',
  link: '/ketoan/bangcong',
  huongdan: Global.App_url
};
export const payroll_cauhinh = {
  id: '1D6B2542-2C1C-4FFC-9280-7886BDF2644E',
  text: 'Cấu hình lương',
  link: '/quantri/cauhinhluong',
  huongdan: Global.App_url
};
export const payroll_thunhap = {
  id: 'FBF4ED65-8450-4BED-96F5-BAF239295076',
  text: 'Thu nhập không thường xuyên',
  link: '/ketoan/thunhapkhongthuongxuyen',
  huongdan: Global.App_url
};
export const payroll_khautru = {
  id: '25425981-B501-4474-99F2-C1436459F145',
  text: 'Khấu trừ không thường xuyên',
  link: '/ketoan/khautrukhongthuongxuyen',
  huongdan: Global.App_url
};
export const payroll_tinhluong = {
  id: 'B5925C7F-6898-4C54-AF64-DBA3F9BEAC0E',
  text: 'Tính lương',
  link: '/ketoan/tinhluong',
  border:'Co',
  huongdan: Global.App_url
};
export const payroll_truylinh = {
  id: 'A6688B24-A4C8-41BB-AB4C-2061985284EE',
  text: 'Truy lĩnh lương',
  link: '/ketoan/truylinhluong',
  huongdan: Global.App_url
};
export const payroll_tinhthuetncn = {
  id: '49152B91-5B71-4A3D-99B6-BD0712689F11',
  text: 'Quản lý thuế TNCN',
  link: '/ketoan/thueTNCN',
  huongdan: Global.App_url
};
export const payroll_noptncn = {
  id: '396AE085-7480-43B7-8CB9-41A9FB33B4F3',
  text: 'Nộp thuế TNCN',
  link: '/ketoan/nopTNCN',
  huongdan: Global.App_url
};
export const payroll_hachtoanluong = {
  id: '8319E0CE-4A72-4592-B11C-74CA27BC24CC',
  text: 'Hạch toán lương',
  link: '/ketoan/hachtoanluong',
  huongdan: Global.App_url
};
export const payroll_traluong = {
  id: 'D031CEEC-45E7-48F8-B641-6E18612555A7',
  text: 'Trả lương',
  link: '/ketoan/traluong',
  huongdan: Global.App_url
};
export const payroll_baohiem = {
  id: 'C028552D-0D34-4838-9077-7952E9AFC45D',
  text: 'Nộp bảo hiểm',
  link: '/ketoan/nopbaohiem',
  border:'Co',
  huongdan: Global.App_url
};
export const payroll_nangcauhinh = {
  id: '3955FF27-9344-4389-A888-58096FD83C9F',
  text: 'Cấu hình truy lĩnh lương',
  link: '/quantri/nangcauhinh',
  huongdan: Global.App_url
};
export const Payroll = {
  id: '',
  text: 'Lương',
  link: '',
  icon: 'fa fas fa-history',
  submenu: [
    //payroll_bangcong,
    payroll_thunhap, payroll_khautru, payroll_truylinh, payroll_tinhluong, payroll_tinhthuetncn, payroll_noptncn, payroll_hachtoanluong, payroll_traluong, payroll_baohiem, Lists_khoanluong, payroll_cauhinh
    //, payroll_nangcauhinh
  ],
  huongdan: Global.App_url
};
//----------------------quản trị
export const System_vaitro = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Vai trò',
  link: '/quantri/vaitro',
  border:'co',
  huongdan: Global.App_url
};
export const System_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const System_thamso = {
  id: 'EB0CE66D-656D-48C9-8BBA-E74309682A18',
  text: 'Tham số hệ thống',
  link: '/quantri/thamso',
  huongdan: Global.App_url
};
export const Ultil_donvi = {
  id: '610562E5-AA28-45CB-811B-F349395DA524',
  text: 'Quản lý đơn vị',
  link: '/quantri/donvi',
  huongdan: Global.App_url
};
export const Ultil_phanhe = {
  id: 'E84CDFB9-E9BB-4E79-9CEB-74BF2C175331',
  text: 'Cấu trúc phân hệ',
  link: '/quantri/phanhe',
  border: 'co',
  huongdan: Global.App_url
};

export const System_history = {
  id: '',
  text: 'Bản mới',
  link: '/danhmuc/history',
  icon: 'fa fas fa-history',
  huongdan: Global.App_url
};
export const Ultil_thietlapngamdinh = {
  id: '62EEB8A0-084B-4D9B-B892-C5CF3C94D6E7',
  text: 'Thiết lập ngầm định',
  link: '/ketoan/thietlapngamdinh',
  huongdan: Global.App_url
};
export const Ultil_saoluudulieu = {
  id: 'DC4D283D-4181-4773-BE7E-D576B1430EB8',
  text: 'Sao lưu dữ liệu',
  link: '/quantri/saoluudulieu',
  huongdan: Global.App_url
};
export const Ultil_nhatkysaoluu = {
  id: '9B779F0A-3D4B-4CDB-87BB-F41529819CC9',
  text: 'Nhật ký sao lưu',
  link: '/quantri/nhatkysaoluu',
  huongdan: Global.App_url
};
export const System = {
  id: '',
  text: 'Hệ thống',
  link: '',
  icon: 'fa fa-cog',
  submenu: [
    System_thamso, Ultil_thietlapngamdinh, Ultil_saoluudulieu, Ultil_nhatkysaoluu, Ultil_nhatkytruycap, System_nguoidung, System_vaitro, Ultil_donvi, Ultil_phanhe,System_history, Ultil_bug
  ],
  huongdan: Global.App_url
};

//-----------------------------------------

//--- dự toán
export const DuToans_dutoanthuxuphat = {
  id: 'C3E10F64-9166-4C91-A2C6-2C9895F44CDE',
  text: 'Dự toán thu ngân sách',
  link: '/dutoan/dutoanthuxuphat',
  huongdan: Global.App_url
};


export const DuToans_dutoantrangbioto = {
  id: '13B637DC-7051-49BD-B6E4-86159080A28E',
  text: 'Dự toán trang bị ô tô',
  link: '/dutoan/dutoantrangbioto',
  huongdan: Global.App_url
};

export const DuToans_dutoantrangbimaytinh = {
  id: 'CFAE507A-F29E-4002-AF8F-AAC258681FF5',
  text: 'Dự toán trang bị máy tính',
  link: '/dutoan/dutoantrangbimaytinh',
  huongdan: Global.App_url
};


export const DuToans_dutoanthutubanhang = {
  id: '11188390-5328-4627-B1D4-97CC53843F66',
  text: 'Dự toán thu từ bán hàng',
  link: '/dutoan/dutoanthuxuphat',
  huongdan: Global.App_url
};
export const DuToans_dutoanthutuhangtieuhuy = {
  id: 'CF89D60E-C9A4-44A4-A040-2D1AE884A6A1',
  text: 'Dự toán thu từ hàng tiêu hủy',
  link: '/dutoan/dutoanthuxuphat',
  huongdan: Global.App_url
};
export const DuToans_dutoanchikhongthuongxuyen = {
  id: 'BC5FAD2A-E5C2-4B5F-9740-153B30EB93B8',
  text: 'Chi quản lý hành chính không tự chủ',
  link: '/dutoan/dutoanchikhongthuongxuyen',
  huongdan: Global.App_url
};
export const DuToans_dutoanchituchu = {
  id: '6ACEF66F-DD8A-4263-BE0E-6F07C64EA5E3',
  text: 'Chi tự chủ',
  link: '/dutoan/dutoanchituchu',
  huongdan: Global.App_url
};
/** Quản lý số liệu dự toán TT26 — chọn biểu mẫu/phân hệ con trên màn hình danh sách */
export const DuToans_dong_tt26 = {
  id: '31C746D8-9B1C-424F-86EE-100452E13C72',
  text: 'Quản lý số liệu dự toán TT26',
  link: '/dutoan/dong',
  huongdan: Global.App_url
};
/** Cấu hình cột & chỉ tiêu dự toán động TT26 */
export const DuToans_dong_cauhinh_tt26 = {
  id: '22222222-2222-2222-2222-222222222201',
  text: 'Cấu hình dự toán động TT26',
  link: '/dutoan/dong-cauhinh',
  huongdan: Global.App_url
};

export const DuToans_dutoanchidaotao = {
  id: 'E457C764-CCC2-480F-8B0A-5543962464B6',
  text: 'Chi sự nghiệp đào tạo',
  link: '/dutoan/dutoanchidaotao',
  huongdan: Global.App_url
};
export const DuToans_dutoanchituchutonghop = {
  id: '2F9B7802-9128-47DD-9E72-6F9FB187ECCD',
  text: 'Chi tự chủ tổng hợp',
  link: '/dutoan/dutoanchituchutonghop',
  huongdan: Global.App_url
};

export const DuToans_dutoanchiyte = {
  id: '3B2D0F11-6733-49EF-A188-508EBF2A9D2D',
  text: 'Chi chương trình mục tiêu Y tế, dân số',
  link: '/dutoan/dutoanchiyte',
  huongdan: Global.App_url
};
export const DuToans_dutoanquyluongcongchuc = {
  id: '1D2F3763-DC3B-4F85-BDA0-358791D8625F',
  text: 'Dự toán quỹ lương công chức',
  link: '/dutoan/dutoanluongcongchuc',
  huongdan: Global.App_url
};
export const DuToans_dutoanquyluongchotuyen = {
  id: '69067956-572D-4D74-99D4-AF98F2F22DBD',
  text: 'Dự toán quỹ lương chờ tuyển, chờ ký HĐ',
  link: '/dutoan/dutoanquyluongchotuyen',
  huongdan: Global.App_url
};
export const DuToans_dutoanquyluong_hd68 = {
  id: '9B51E6F3-7B6F-4989-9F00-97816C12FE44',
  text: 'Dự toán quỹ lương HĐ 68',
  link: '/dutoan/dutoanquyluonghd',
  huongdan: Global.App_url
};
export const DuToans_dutoantrangphuc = {
  id: 'FACB3A81-D316-47D5-9E0B-1F16C7CB54B4',
  text: 'Dự toán trang phục',
  link: '/dutoan/dutoantrangphuc',
  huongdan: Global.App_url
};
export const DuToans_dutoananchi = {
  id: '6C0F7AF3-AA87-4049-92BD-22300A47905D',
  text: 'Dự toán ấn chỉ',
  link: '/dutoan/dutoananchi',
  huongdan: Global.App_url
};
export const DuToans_dutoankinhphixuphat153 = {
  id: '43C242EE-57FE-4F71-BA9B-20458DEFBA0F',
  text: 'Dự toán kinh phí xử phạt 153',
  link: '/dutoan/dutoankinhphixuphat153',
  huongdan: Global.App_url
};
export const DuToans_dutoanmuasamtaisan = {
  id: 'D622070E-4BAC-4D21-9F56-65A357754082',
  text: 'Dự toán mua sắm tài sản',
  link: '/dutoan/dutoanmuasamtaisan',
  huongdan: Global.App_url
};
export const DuToans_dutoanpheduyet = {
  id: '0E0C10EB-40F7-4E6E-A67F-B9E121CF6BB9',
  text: 'Phê duyệt dự toán',
  link: '/dutoan/pheduyetdutoan',
  huongdan: Global.App_url
};
export const DuToans_dutoansuachua = {
  id: '5031FB5C-6152-4970-9C24-4EAF4DE458DF',
  text: 'Dự toán sửa chữa',
  link: '/dutoan/dutoansuachua',
  huongdan: Global.App_url
};
export const DuToans_dutoanthuetruso = {
  id: '3B428FB2-7207-41BC-BB07-C3840B520796',
  text: 'Dự toán thuê trụ sở, kho bãi',
  link: '/dutoan/dutoanthuetruso',
  huongdan: Global.App_url
};
export const DuToans_dutoanchodetai = {
  id: '7069FC02-4F88-4477-B868-21596A0D0EA6',
  text: 'Dự toán cho đề án',
  link: '/dutoan/dutoanchodetai',
  huongdan: Global.App_url
};
export const DuToans_dutoandoankiemtra = {
  id: '08EB2B52-A37C-4186-A71D-7AF0307AD8E4',
  text: 'Dự toán đoàn kiểm tra liên ngành',
  link: '/dutoan/dutoandoankiemtra',
  huongdan: Global.App_url
};
export const DuToans_dutoankhoasolieu = {
  id: '9C82DFE8-BF7F-459F-A22A-872393CBEC56',
  text: 'Khóa số liệu dự toán',
  link: '/dutoan/dutoankhoasolieu',
  huongdan: Global.App_url
};
export const DuToans_dutoandieuchinh = {
  id: '38BF8C51-4DBA-4BDB-810D-6E4BD16A16DA',
  text: 'Phân bổ dự toán',
  link: '/dutoan/phanbodutoan',
  huongdan: Global.App_url
};
export const DuToans_dutoanhuy = {
  id: '48FC391C-6E9F-4D1C-AD15-7224C8986472',
  text: 'Hủy dự toán',
  link: '/dutoan/dutoanhuy',
  huongdan: Global.App_url
};



export const DuToans_tongnhucauvadukienkehoachdautu = {
  id: BaoCao.BC150_DuToan_TongNhuCauVaDuKienKeHoachDauTu,
  text: 'Tổng nhu cầu và dự kiến kế hoạch đầu tư',
  link: '/baocaodutoan/tongnhucauvadukienkehoachdautu/' + BaoCao.BC150_DuToan_TongNhuCauVaDuKienKeHoachDauTu,
  huongdan: Global.App_url
};

export const DuToans_chitietdukienkehoachdautu = {
  id: BaoCao.BC151_DuToan_ChiTietDuKienKeHoachDauTu,
  text: 'Chi tiết dự kiến kế hoạch đầu tư',
  link: '/baocaodutoan/chitietdukienkehoachdautu/' + BaoCao.BC151_DuToan_ChiTietDuKienKeHoachDauTu,
  huongdan: Global.App_url
};

export const DuToans_tonghopketquagiao = {
  id: BaoCao.BC152_DuToan_TongHopKetQuaGiaoVaKeHoachDauTu,
  text: 'Tổng hợp kết quả giao và thông báo kế hoạch đầu tư',
  link: '/baocaodutoan/tonghopketquagiao/' + BaoCao.BC152_DuToan_TongHopKetQuaGiaoVaKeHoachDauTu,
  huongdan: Global.App_url
};
export const DuToans_chitietketquagiao = {
  id: BaoCao.BC153_ChiTietKetQuaGiaoVaThongBaoKeHoachDauTu,
  text: 'Chi tiết kết quả giao và thông báo kế hoạch đầu tư',
  link: '/baocaodutoan/chitietketquagiao/' + BaoCao.BC153_ChiTietKetQuaGiaoVaThongBaoKeHoachDauTu,
  huongdan: Global.App_url
};
export const DuToans_tinhhinhthuchienvakehoachgiaingandautu = {
  id: BaoCao.BC154_DuToan_TongHopTinhHinhThucHienVaKeHoachGiaiNganDauTu,
  text: 'Tổng hợp tình hình thực hiện và kế hoạch giải ngân đầu tư',
  link: '/baocaodutoan/tinhhinhthuchienvakehoachgiaingandautu/' + BaoCao.BC154_DuToan_TongHopTinhHinhThucHienVaKeHoachGiaiNganDauTu,
  huongdan: Global.App_url
};

export const DuToans_tinhhinhthuchienvakehoachdautuphattrien = {
  id: BaoCao.BC155_TongHopTinhHinhThucHienKeHoachDauTuPhatTrien,
  text: 'Tổng hợp tình hình thực hiện kế hoạch đầu tư phát triển',
  link: '/baocaodutoan/tinhhinhthuchienvakehoachdautuphattrien/' + BaoCao.BC155_TongHopTinhHinhThucHienKeHoachDauTuPhatTrien,
  huongdan: Global.App_url
};

export const DuToans_chitiettinhhinhthuchienkehoachdautu = {
  id: BaoCao.BC156_ChiTietTinhHinhThucHienKeHoachDauTu,
  text: 'Chi tiết tình hình thực hiện kế hoạch đầu tư (theo dự án)',
  link: '/baocaodutoan/chitiettinhhinhthuchienkehoachdautu/' + BaoCao.BC156_ChiTietTinhHinhThucHienKeHoachDauTu,
  huongdan: Global.App_url
};

export const DuToans_chitiettinhhinhthuchienvagiaingantheokehoachdautu = {
  id: BaoCao.BC157_ChiTietTinhHinhThucHienVaGiaiNganTheoKeHoachDauTu,
  text: 'Chi tiết tình hình thực hiện và giải ngân theo kế hoạch đầu tư',
  link: '/baocaodutoan/chitiettinhhinhthuchienvagiaingantheokehoachdautu/' + BaoCao.BC157_ChiTietTinhHinhThucHienVaGiaiNganTheoKeHoachDauTu,
  huongdan: Global.App_url
};

export const DuToans_bangtonghopquyluongcongchuc = {
  id: BaoCao.BC158_BangTongHopQuyLuongCongChuc,
  text: 'Bảng tổng hợp quỹ lương cho công chức',
  link: '/baocaodutoan/bangtonghopquyluongcongchuc/' + BaoCao.BC158_BangTongHopQuyLuongCongChuc,
  huongdan: Global.App_url
};

export const DuToans_bangtonghopquyluongchotuyen = {
  id: BaoCao.BC159_BangTongHopQuyLuongChoTuyen,
  text: 'Bảng tổng hợp quỹ lương chờ tuyển',
  link: '/baocaodutoan/bangtonghopquyluongchotuyen/' + BaoCao.BC159_BangTongHopQuyLuongChoTuyen,
  huongdan: Global.App_url
};

export const DuToans_bangtonghopquyluonghd68 = {
  id: BaoCao.BC160_BangTongHopQuyLuongHD68,
  text: 'Bảng tổng hợp quỹ lương HĐ 68',
  link: '/baocaodutoan/bangtonghopquyluonghd68/' + BaoCao.BC160_BangTongHopQuyLuongHD68,
  huongdan: Global.App_url
};

export const DuToans_bangtonghopquyluong = {
  id: BaoCao.BC161_BangTongHopQuyLuong,
  text: 'Bảng tổng hợp quỹ lương',
  link: '/baocaodutoan/bangtonghopquyluong/' + BaoCao.BC161_BangTongHopQuyLuong,
  huongdan: Global.App_url
};
export const DuToans_thuyetminhtonghopdutoan = {
  id: BaoCao.BC163_ThuyetMinhTongHopDuToan,
  text: 'Thuyết minh tổng hợp dự toán',
  link: '/baocaodutoan/thuyetminhtonghopdutoan/' + BaoCao.BC163_ThuyetMinhTongHopDuToan,
  huongdan: Global.App_url
};

export const DuToans_dutoanthuchingansachduocgiaovaphanbo = {
  id: BaoCao.BC164_DuToanThuChiNganSachDuocGiaoVaPhanBo,
  text: 'Dự toán thu - chi ngân sách được giao và phân bổ cho đơn vị trực thuộc',
  link: '/baocaodutoan/dutoanthuchingansachduocgiaovaphanbo/' + BaoCao.BC164_DuToanThuChiNganSachDuocGiaoVaPhanBo,
  huongdan: Global.App_url
};

export const DuToans_dutoanthuchingansach = {
  id: BaoCao.BC165_DuToanThuChiNSNN,
  text: 'Dự toán thu - chi ngân sách nhà nước',
  link: '/baocaodutoan/dutoanthuchingansach/' + BaoCao.BC165_DuToanThuChiNSNN,
  huongdan: Global.App_url
};

export const DuToans_danhgiathuchiendutoanthuchins = {
  id: BaoCao.BC166_DanhGiaThucHienDuToanThuChiNS,
  text: 'Đánh giá thực hiện dự toán thu chi ngân sách',
  link: '/baocaodutoan/danhgiathuchiendutoanthuchins/' + BaoCao.BC166_DanhGiaThucHienDuToanThuChiNS,
  huongdan: Global.App_url
};

export const DuToans_dutoanthuchiduocgiaophanbochodonvitructhuoc = {
  id: BaoCao.BC167_DuToanThuChiNSNNDuocGiaoVaPhanBoChoDonViTrucThuoc,
  text: 'Dự toán thu chi ngân sách nhà nước hỗ trợ được giao và phân bổ cho đơn vị trực thuộc',
  link: '/baocaodutoan/dutoanthuchiduocgiaophanbochodonvitructhuoc/' + BaoCao.BC167_DuToanThuChiNSNNDuocGiaoVaPhanBoChoDonViTrucThuoc,
  huongdan: Global.App_url
};

export const DuToans_baocaodutoanthuchingansach = {
  id: BaoCao.BC168_DuToanThuChiNganSach,
  text: 'Dự toán thu chi ngân sách',
  link: '/baocaodutoan/baocaodutoanthuchingansach/' + BaoCao.BC168_DuToanThuChiNganSach,
  huongdan: Global.App_url
};
export const DuToans_soxulyviphamhanhchinh = {
  id: BaoCao.BC169_SoXuLyViPhamHanhChinh,
  text: 'Sổ xử lý vi phạm hành chính',
  link: '/baocaodutoan/soxulyviphamhanhchinh/' + BaoCao.BC169_SoXuLyViPhamHanhChinh,
  huongdan: Global.App_url
};
export const DuToans_TongHopDuToanThuNganSach = {
  id: BaoCao.BC170_TongHopDuToanThuNganSach,
  text: 'Phụ lục 10: Báo cáo tổng hợp nhu cầu thu chi giai đoạn 3 năm',
  link: '/baocaodutoan/tonghopdutoanthungansach/' + BaoCao.BC170_TongHopDuToanThuNganSach,
  huongdan: Global.App_url
};

export const DuToans_TongHopDuToanThuNganSach01 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc01,
  text: 'Phụ lục 07: Báo cáo danh sách tinh giản biên chế',
  link: '/baocaodutoan/tonghopdutoanthungansach01/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc01,
  huongdan: Global.App_url
};
export const DuToans_TongHopDuToanThuNganSach02 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc02,
  text: 'Phụ lục 08: Báo cáo kinh phí dành cho công tác đào tạo',
  link: '/baocaodutoan/tonghopdutoanthungansach02/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc02,
  huongdan: Global.App_url
};
export const DuToans_BangTongHopQuyLuong03 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc03,
  text: 'Phụ lục 01, 02: Bảng tổng hơp quỹ lương',
  link: '/baocaodutoan/bangtonghopquyluong03/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc03,
  huongdan: Global.App_url
};

export const DuToans_KeHoachThucHienNhiemVu04 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc04,
  text: 'Phụ lục 05: Kế hoạch thực hiện nhiệm vụ và nội dung chi KTC',
  link: '/baocaodutoan/kehoachthuchiennhiemvu04/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc04,
  huongdan: Global.App_url
};

export const DuToans_KeHoachThucHienNhiemVu05 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc05,
  text: 'Phụ lục 03: Kế hoạch thực hiện nhiệm vụ và nội dung chi KTC',
  link: '/baocaodutoan/kehoachthuchiennhiemvu05/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc05,
  huongdan: Global.App_url
};
export const DuToans_BangTongHopQuyLuong06 = {
  id: BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc06,
  text: 'Phụ lục 04: Bảng tổng hợp quỹ lương HĐ',
  link: '/baocaodutoan/kehoachthuchiennhiemvu06/' + BaoCao.BC_DT_ThuChiNganSach_TH_PhuLuc06,
  huongdan: Global.App_url
};



export const DuToans_TongHopDuToanThuNganSach07 = {
  id: BaoCao.BC_DT_ThuNganSach_TH_PhuLuc07,
  text: 'Phụ lục 09: Báo cáo tổng hợp số thu từ công tác XPHC',
  link: '/baocaodutoan/tonghopdutoanthungansach07/' + BaoCao.BC_DT_ThuNganSach_TH_PhuLuc07,
  huongdan: Global.App_url
};
export const DuToans_TongHopDuToanThuNganSach08 = {
  id: BaoCao.BC_DT_ThuNganSach_TH_PhuLuc08,
  text: 'Phụ lục 11: Báo cáo thực hiện nhiệm vụ ngân sách nhà nước',
  link: '/baocaodutoan/tonghopdutoanthungansach08/' + BaoCao.BC_DT_ThuNganSach_TH_PhuLuc08,
  huongdan: Global.App_url
};
export const DuToans_ThuyetMinhDuToan09 = {
  id: BaoCao.BC_DT_ThuyetMinhTangGiamDuToan_PhuLuc09,
  text: 'Phụ lục 06: Báo cáo danh sách công trình cải tạo, sửa chữa',
  link: '/baocaodutoan/thuyetminhtanggiamdutoan/' + BaoCao.BC_DT_ThuyetMinhTangGiamDuToan_PhuLuc09,
  huongdan: Global.App_url
};

export const DuToans_ThuyetMinhDuToanPL16 = {
  id: BaoCao.BC_DT_ThuyetMinhTangGiamDuToan_PhuLuc09,
  text: 'Phụ lục 16: Báo cáo danh sách tài sản khác',
  link: '/baocaodutoan/thuyetminhtanggiamdutoan/2780A6F1-5192-49CD-B3BA-17E3488BFA81',
  huongdan: Global.App_url
};

export const DuToans_ThuyetMinhDuToanPL17 = {
  id: BaoCao.BC_DT_ThuyetMinhTangGiamDuToan_PhuLuc09,
  text: 'Phụ lục 17: Danh sách Máy đo chỉ số Octane xăng dầu',
  link: '/baocaodutoan/thuyetminhtanggiamdutoan/B77FA6BB-158A-4C6E-B198-0B714AD49A25',
  huongdan: Global.App_url
};

export const DuToans_TongHopDuToanMuaSamTrangPhuc = {
  id: BaoCao.BC_DT_TongHopDuToanTrangPhuc_TH_PhuLuc12,
  text: 'Phụ lục 12: Bảng tổng hợp dự toán mua sắm trang phục',
  link: '/baocaodutoan/tonghopdutoanmuasamtrangphuc12/' + BaoCao.BC_DT_TongHopDuToanTrangPhuc_TH_PhuLuc12,
  huongdan: Global.App_url
};



export const DuToans_TongHopDuToanTrangBiOto = {
  id: '539AEEB6-52D1-46FA-B04B-480DE9E44255',
  text: 'Phụ lục 13: Bảng tổng hợp dự toán trang bị ô tô',
  link: '/baocaodutoan/tonghopdutoantrangbioto/' + '539AEEB6-52D1-46FA-B04B-480DE9E44255',
  huongdan: Global.App_url
};

export const DuToans_TongHopDuToanTrangBiMayTinh = {
  id: 'F7C78144-882E-45CE-8DB6-1EA91B821A45',
  text: 'Phụ lục 14: Bảng tổng hợp dự toán trang bị máy tính, máy in',
  link: '/baocaodutoan/tonghopdutoantrangbimaytinh/' + 'F7C78144-882E-45CE-8DB6-1EA91B821A45',
  huongdan: Global.App_url
};

export const DuToans_TongHopDuToanThietBiChuyenDung = {
  id: BaoCao.BC_DT_TongHopDuToanThietBiChuyenDung_TH_PhuLuc15,
  text: 'Phụ lục 15: Bảng tổng hợp dự toán thiết bị chuyên dùng',
  link: '/baocaodutoan/tonghopdutoanthietbi15/' + BaoCao.BC_DT_TongHopDuToanThietBiChuyenDung_TH_PhuLuc15,
  huongdan: Global.App_url
};

export const DuToans_ThongKeBaoCaoDuToanTT26 = {
  id: BaoCao.BC_DT_ThongKeBaoCaoDuToan_TT26,
  text: 'Thống kê báo cáo dự toán TT26',
  link: '/baocaodutoan/thongkebaocaodutoantt26/' + BaoCao.BC_DT_ThongKeBaoCaoDuToan_TT26,
  huongdan: Global.App_url
};


export const DuToans_chitieu = {
  id: 'A4768A90-EC0B-43F1-AD57-A9935F939F9E',
  text: 'Chỉ tiêu dự toán chi',
  link: '/dutoan/chitieuchi/',
  huongdan: Global.App_url
};
export const DuToans_chitieuthu = {
  id: '11ea3811-2cfe-4e85-9184-989ffbe6f0d6',
  text: 'Chỉ tiêu thu ngân sách',
  link: '/dutoan/chitieuthu/',
  huongdan: Global.App_url
};
export const DuToans_dmmuasamtaptrung = {
  id: '9EE80858-B031-4DF3-8431-67EF5391990F',
  text: 'Danh mục mua sắm tập trung',
  link: '/danhmuc/muasamtaptrung/',
  huongdan: Global.App_url
};
export const DuToans_dmtrangphuc = {
  id: '2015CCBB-79BE-4763-B86A-16D6BABCF56E',
  text: 'Danh mục trang phục',
  link: '/danhmuc/trangphucquanao/',
  huongdan: Global.App_url
};
export const DuToans_dmcongcuhotro = {
  id: 'DC2BB0D1-D22B-4F81-9A58-5EC4D81B6AD3',
  text: 'Danh mục công cụ',
  link: '/danhmuc/congcuhotro/',
  huongdan: Global.App_url
};

export const DuToans_dmthietbichuyendung = {
  id: '4C96618D-E244-4739-9DE7-822500118BC0',
  text: 'Danh mục thiết bị chuyên dùng',
  link: '/danhmuc/thietbichuyendung/',
  huongdan: Global.App_url
};

export const DuToans_phienban = {
  id: '6EEDE551-78CE-44B2-A4C4-B126336BD344',
  text: 'Quản lý phiên bản',
  link: '/dutoan/quanlyphienban/',
  huongdan: Global.App_url
};


export const DuToans = {
  id: '',
  text: ' Dự toán',
  link: '/dutoans',
  icon: 'fa fas fa-money-check',
  submenu: [
    DuToans_phienban,

    DuToans_dong_tt26,
    DuToans_dong_cauhinh_tt26,
    DuToans_ThongKeBaoCaoDuToanTT26,

    //{
    //  id: '',
    //  text: 'Dự toán theo TT26',
    //  link: '/elements',
    //  icon: 'fa fa-list-ul',
    //  submenu:
    //    [
          
    //      DuToans_dong_tt26,
    //      DuToans_dong_cauhinh_tt26,
    //      DuToans_ThongKeBaoCaoDuToanTT26,
         
    //    ]
    //},



    DuToans_dutoanthuxuphat,
    //{
    //  id: '',
    //  text: 'Dự toán thu',
    //  link: '/elements',
    //  icon: 'fa fa-list-ul',
    //  submenu:
    //    [
    //      DuToans_dutoanthuxuphat,
    //      DuToans_dutoanthutubanhang,
    //      DuToans_dutoanthutuhangtieuhuy,
    //      DuToans_TongHopDuToanThuNganSach,
    //    ]
    //},
    {
      id: '',
      text: 'Bảng lương',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          DuToans_dutoanquyluongchotuyen,
          DuToans_dutoanquyluongcongchuc,
          DuToans_dutoanquyluong_hd68,
        ]
    },
    {
      id: '',
      text: 'Dự toán chi',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          //DuToans_dutoanchituchu,
         // DuToans_dutoanchituchutonghop,
          DuToans_dutoanchidaotao,
          DuToans_dutoanchikhongthuongxuyen,
          DuToans_dutoantrangbioto,
          DuToans_dutoantrangbimaytinh
          
          //DuToans_dutoanchiyte,
        ]
    },
   
    {
      id: '',
      text: 'Báo cáo',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [

        DuToans_BangTongHopQuyLuong03,
        DuToans_KeHoachThucHienNhiemVu05,
        DuToans_BangTongHopQuyLuong06,
        DuToans_KeHoachThucHienNhiemVu04,
        DuToans_ThuyetMinhDuToan09,
        DuToans_TongHopDuToanThuNganSach01,
        DuToans_TongHopDuToanThuNganSach02,
        DuToans_TongHopDuToanThuNganSach07,
        DuToans_TongHopDuToanThuNganSach,
        DuToans_TongHopDuToanThuNganSach08,
        DuToans_TongHopDuToanMuaSamTrangPhuc,
        DuToans_TongHopDuToanTrangBiOto,
        DuToans_TongHopDuToanTrangBiMayTinh,
        DuToans_TongHopDuToanThietBiChuyenDung,
        DuToans_ThuyetMinhDuToanPL16,
        DuToans_ThuyetMinhDuToanPL17





        //DuToans_tongnhucauvadukienkehoachdautu,
        //DuToans_chitietdukienkehoachdautu,
        //DuToans_tonghopketquagiao,
        //DuToans_chitietketquagiao,
        //DuToans_tinhhinhthuchienvakehoachgiaingandautu,
        //DuToans_tinhhinhthuchienvakehoachdautuphattrien,
        //DuToans_chitiettinhhinhthuchienkehoachdautu,
        //DuToans_chitiettinhhinhthuchienvagiaingantheokehoachdautu,
        //DuToans_bangtonghopquyluongcongchuc,
        //DuToans_bangtonghopquyluongchotuyen,
        //DuToans_bangtonghopquyluonghd68,
        //DuToans_bangtonghopquyluong,
        //DuToans_thuyetminhtonghopdutoan,
        //DuToans_dutoanthuchingansachduocgiaovaphanbo,
        //DuToans_dutoanthuchingansach,
        //DuToans_danhgiathuchiendutoanthuchins,
        //DuToans_dutoanthuchiduocgiaophanbochodonvitructhuoc,
        //DuToans_baocaodutoanthuchingansach,
        //DuToans_soxulyviphamhanhchinh,

      ]
    },
    {
      id: '',
      text: 'Danh mục',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          DuToans_chitieu,
          DuToans_dmmuasamtaptrung,
          DuToans_dmcongcuhotro,
          DuToans_dmtrangphuc,
          DuToans_chitieuthu,
          DuToans_dmthietbichuyendung
        ]
    },
    //DuToans_dutoanpheduyet,
    DuToans_dutoandieuchinh,
    //DuToans_dutoanhuy,
    DuToans_dutoankhoasolieu,

   ]
};
//--- dự toán

//--- quyết toán
export const QuyetToans_baocaochitietkinhphi = {
  id: '4864E1F0-FAE5-43E8-8DC7-7CE0E6661FB9',
  text: 'Nhập báo cáo chi tiết kinh phí',
  link: '/quyettoan/bc01',
  huongdan: Global.App_url
};
export const QuyetToans_baocaochitietkinhphimaumoi = {
  id: '4864E1F0-FAE5-43E8-8DC7-7CE0E6661FB9',
  text: 'Nhập báo cáo chi tiết kinh phí (TT 107 và TT24)',
  link: '/quyettoan/bc12',
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghopkinhphi = {
  id: '3965D1BC-E4C0-4730-9E5D-6674C1AEFAD8',
  text: 'Nhập báo cáo tổng hợp kinh phí',
  link: '/quyettoan/bc03',
  huongdan: Global.App_url
};
export const QuyetToans_baocaotonghopkinhphimaumoi = {
  id: '3965D1BC-E4C0-4730-9E5D-6674C1AEFAD8',
  text: 'Nhập báo cáo tổng hợp kinh phí (TT 107 và TT24)',
  link: '/quyettoan/bc31',
  huongdan: Global.App_url
};

export const QuyetToans_baocaothuchihoatdongsunghiep = {
  id: '6214C01C-9F44-4F2A-B93D-78457E6C8FB6',
  text: 'Nhập báo cáo thu chi hoạt động sự nghiệp và hoạt động dịch vụ',
  link: '/quyettoan/bc02',
  huongdan: Global.App_url
};

export const QuyetToans_baothuphi1a = {
  id: '286F3F12-63AD-4F2F-8ACC-A3874D70390A',
  text: 'Nhập báo cáo thu phí, lệ phí (mẫu 1a)',
  link: '/quyettoan/bc04',
  huongdan: Global.App_url
};

export const QuyetToans_baocaoketquahoatdong1b02 = {
  id: 'D2C76005-7C71-4F77-8679-8A188D5DA655',
  text: 'Nhập báo cáo kết quả hoạt động (Mẫu B02-TT107, TT24)',
  link: '/quyettoan/bc05',
  huongdan: Global.App_url
};
export const QuyetToans_baocaoketquahoatdong1b05 = {
  id: '5C9095BD-D9AE-4D84-B76E-A564270E1498',
  text: 'Nhập báo cáo kết quả hoạt động (mẫu 1b-B05 - TT107)',
  link: '/quyettoan/bc06',
  huongdan: Global.App_url
};

export const QuyetToans_baocaoketquahoatdongb02_24 = {
  id: 'D2C76005-7C71-4F77-8679-8A188D5DA655',
  text: 'Nhập báo cáo kết quả hoạt động (mẫu B02/BCTC - TT24)',
  link: '/quyettoan/bc051',
  huongdan: Global.App_url
};


export const QuyetToans_baocaotaichinh_b01bctc = {
  id: '169E6049-D411-4A35-9146-B84736F79C1A',
  text: 'Nhập báo cáo tình hình tài chính(B01/BCTC)-TT107, TT24',
  link: '/quyettoan/bc07',
  huongdan: Global.App_url
};

export const QuyetToans_luuchuyentiente_b03abctc = {
  id: 'BC51BA05-E387-4017-B435-78F4A4E01AE1',
  text: 'Nhập báo cáo lưu chuyển tiền tệ (B03a/BCTC-TT107, TT24)',
  link: '/quyettoan/bc08',
  huongdan: Global.App_url
};

export const QuyetToans_luuchuyentiente_b03bbctc = {
  id: '047D85BD-0CA5-4307-89DF-284DDF45D3D9',
  text: 'Nhập báo cáo lưu chuyển tiền tệ (B03b/BCTC)-TT108',
  link: '/quyettoan/bc11',
  huongdan: Global.App_url
};

export const QuyetToans_thuyetminhtaichinh = {
  id: '83DAC068-96F2-45C6-AA71-EAF4A95BBC13',
  text: 'Nhập báo cáo thuyết minh báo cáo tài chính (B04/BCTC)-TT107, TT24',
  link: '/quyettoan/bc09',
  huongdan: Global.App_url
};
export const QuyetToans_nhapbaocaobosungthongtintaichinh = {
  id: '4834108F-8607-4D7E-AE8D-8461495A1625',
  text: 'Nhập báo cáo bổ sung thông tin tài chính(B01/BSTT) - TT99',
  link: '/quyettoan/bc10',
  huongdan: Global.App_url
};

//id: 'BC5FAD2A-E5C2-4B5F-9740-153B30EB93B8',
export const QuyetToans_baocaotinhhinhthuchien_nsnn = {
  id: 'AD476CCD-201D-468B-9A18-6EEB34ADD052',
  text: 'Nhập báo cáo tình hình thực hiện NSNN (TT107)',
  link: '/quyettoan/bc13',
  huongdan: Global.App_url
};

export const QuyetToans_baocaotinhhinhthuchien_nsnn2 = {
  id: 'CA8306EA-92A6-49BD-8E59-97623BFB0BBF',
  text: 'Nhập báo cáo tình hình thực hiện NSNN(mẫu 2023)-TT107, TT24',
  link: '/quyettoan/bc14',
  huongdan: Global.App_url
};


export const QuyetToans_nhapbangcandoiphatsinh = {
  id: '85E108EF-04D1-48FA-B30C-EE31BABE50C3',
  text: 'Nhập báo cáo bảng cân đối số phát sinh(S05-H)-TT107, TT24',
  link: '/quyettoan/bc32',
  huongdan: Global.App_url
};

export const QuyetToans_thongtintaisanc03 = {
  id: 'F25C5D88-DE52-4D0B-BAC8-F56483427EFA',
  text: 'Nhập báo cáo thông tin tài sản mẫu C03/CCTT-TT39',
  link: '/quyettoan/bc33',
  huongdan: Global.App_url
};

export const QuyetToans_nhapbaocaotinhhinhtanggiamtscd = {
  id: '7FC4D96C-E668-4B41-99AD-C7F24BD2C94C',
  text: 'Nhập báo cáo tình hình tăng giảm TSCĐ-TT107, TT24',
  link: '/quyettoan/bc34',
  huongdan: Global.App_url
};
export const QuyetToans_baocaotaichinh_b05bctc = {
  id: '18700C60-6AD7-4C5A-AD46-537A4AC4595D',
  text: 'Nhập báo cáo về những thay đổi trong tài sản thuần-TT24',
  link: '/quyettoan/bc35',
  huongdan: Global.App_url
};


export const QuyetToans_khoasolieubaocao = {
  id: '1CE56C7B-2F24-41C6-B52A-FF6EE356CAFC',
  text: 'Khóa số liệu',
  link: '/quyettoan/khoasolieubaocao',
  huongdan: Global.App_url
};

export const QuyetToans_quyettoanloaikhoan = {
  id: '052F8DBB-DC86-410C-8823-FEE4B9D1F4EF',
  text: 'Danh mục loại khoản',
  link: '/quyettoan/loaikhoan',
  huongdan: Global.App_url
};
export const QuyetToans_quyettoanloaikhoanchung = {
  id: '052F8DBB-DC86-410C-8823-FEE4B9D1F4EF',
  text: 'Danh mục loại khoản (mẫu tổng hợp và chi tiết kinh phí mới)',
  link: '/quyettoan/loaikhoanchung',
  huongdan: Global.App_url
};


export const QuyetToans_chitieuthuchihoatdongsunghiep = {
  id: '048FD13F-4456-44B3-87B1-1BC432E5D09C',
  text: 'Danh mục chỉ tiêu thu chi HĐ sự nghiệp và Dịch vụ ',
  link: '/quyettoan/chitieu',
  huongdan: Global.App_url
};
export const QuyetToans_danhmuctieumuc = {
  id: '8DF41B33-409E-45C8-B3D1-E91BC78DC048',
  text: 'Danh mục mục - tiểu mục',
  link: '/quyettoan/tieumuc',
  huongdan: Global.App_url
};
export const QuyetToans_danhmucchitieu1a = {
  id: '9D37504D-6C80-4BED-9E58-27EBF6EF871A',
  text: 'Danh mục chỉ tiêu mẫu 1a',
  link: '/quyettoan/chitieumau1a',
  huongdan: Global.App_url
};
export const QuyetToans_danhmucchitieu1b02 = {
  id: '1AC7D419-B01C-4B66-9223-0D0A74A4AAF4',
  text: 'Danh mục chỉ tiêu mẫu 1b-B02',
  link: '/quyettoan/chitieumau1b',
  huongdan: Global.App_url
};
export const QuyetToans_danhmucchitieu1b05 = {
  id: '340D3554-66DC-46BD-A893-0A1E797B6E0E',
  text: 'Danh mục chỉ tiêu mẫu 1b-B05',
  link: '/quyettoan/chitieumau1b05',
  huongdan: Global.App_url
};

export const QuyetToans_cauhinhchitieubaocaochitiet = {
  id: 'DF6D9B3E-BD40-444A-BAC6-E60E99211737',
  text: 'Cấu hình tiểu mục nhập báo cáo chi tiết kinh phí',
  link: '/quyettoan/cauhinhtieumuc',
  huongdan: Global.App_url
};
export const QuyetToans_cauhinhchitieubaocaochitietmaumoi = {
  id: 'DF6D9B3E-BD40-444A-BAC6-E60E99211737',
  text: 'Cấu hình tiểu mục nhập báo cáo chi tiết kinh phí (mẫu mới)',
  link: '/quyettoan/cauhinhchitiet',
  huongdan: Global.App_url
};

export const QuyetToans_cauhinhchitieuthuchisunghiep = {
  id: 'A1927326-0735-4E15-9415-2CDF8292B8A7',
  text: 'Cấu hình chỉ tiêu thu chi hoạt động sự nghiệp và hoạt động dịch vụ',
  link: '/quyettoan/cauhinhchitieu',
  huongdan: Global.App_url
};

export const QuyetToans_cauhinhchitieumau1a = {
  id: 'F5FD5134-D184-46E7-872E-8793B0B03001',
  text: 'Cấu hình chỉ tiêu mẫu 1a',
  link: '/quyettoan/cauhinhchitieumau1a',
  huongdan: Global.App_url
};



export const QuyetToans_tonghopchitietkinhphi_th = {
  id: BaoCao.BC200_TongHopChiTietKinhPhi_TH,
  text: 'BC tổng hợp chi tiết kinh phí (mẫu TH)',
  link: '/baocaoquyettoan/tonghopchitietkinhphi_th/' + BaoCao.BC200_TongHopChiTietKinhPhi_TH,
  huongdan: Global.App_url
};
export const QuyetToans_tonghopchitietkinhphi_thmaumoi = {
  id: BaoCao.BC200_TongHopChiTietKinhPhi_TH,
  text: 'BC tổng hợp chi tiết kinh phí (mẫu TH mẫu mới)-TT107, TT24',
  link: '/baocaoquyettoan/tonghopchitietkinhphi_thmaumoi/' + BaoCao.BC200_TongHopChiTietKinhPhi_TH,
  huongdan: Global.App_url
};

export const QuyetToans_tonghopbaocao_xml = {
  id: BaoCao.BC208_BaoCaoKiemTraLoi,
  text: 'Xuất tổng hợp báo cáo quyết toán nhập dvc file xml',
  link: '/baocaoquyettoan/tonghopbaocaoxml/8174BDAB-4994-4CD0-9D8C-C9B880671189',
  huongdan: Global.App_url
};


export const QuyetToans_tonghopchitietkinhphi_donvi = {
  id: BaoCao.BC201_TongHopChiTietKinhPhi_DonVi,
  text: 'BC tổng hợp chi tiết kinh phí (mẫu theo đơn vị)',
  link: '/baocaoquyettoan/tonghopchitietkinhphi_donvi/' + BaoCao.BC201_TongHopChiTietKinhPhi_DonVi,
  huongdan: Global.App_url
};

export const QuyetToans_baocaothuchihoatdongsunghiepdichvu = {
  id: BaoCao.BC202_BaoCaoThuChiHoatDongSuNghiepVaDichVu,
  text: 'BC thu chi HĐ sự nghiệp và HĐ dịch vụ',
  link: '/baocaoquyettoan/baocaothuchihoatdongsunghiepdichvu/' + BaoCao.BC202_BaoCaoThuChiHoatDongSuNghiepVaDichVu,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_bienban_tatca = {
  id: BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa,
  text: 'BC tổng hợp (mẫu biên bản tất cả)',
  link: '/baocaoquyettoan/baocaotonghop_bienban_tatca/' + BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_bienban_tatcamaumoi = {
  id: BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa, 
  text: 'BC tổng hợp (mẫu biên bản tất cả mẫu mới)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_bienban_tatcamaumoi/' + BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa,
  huongdan: Global.App_url
};

export const QuyetToans_baocaoquyettoanthuchingansach_bieuso8 = {
  id: BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa,
  text: 'BC quyết toán thu - chi ngân sách nhà nước',
  link: '/baocaoquyettoan/baocaoquyettoanthuchingansach_bieuso8/' + BaoCao.BC203_BaoCaoTongHop_BienBan_TatCa,
  huongdan: Global.App_url
};


export const QuyetToans_baocaotonghop_bienban_loaikhoan = {
  id: BaoCao.BC204_BaoCaoTongHop_BienBan_LoaiKhoan,
  text: 'BC tổng hợp (mẫu biên bản theo loại khoản)',
  link: '/baocaoquyettoan/baocaotonghop_bienban_loaikhoan/' + BaoCao.BC204_BaoCaoTongHop_BienBan_LoaiKhoan,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_thuchien_nsnn = {
  id: BaoCao.BC217_BaoCaoTongHop_ThucHienNSNN,
  text: 'BC tổng hợp tình hình thực hiện NSNN-TT107',
  link: '/baocaoquyettoan/baocaotonghop_thuchien_nsnn/' + BaoCao.BC217_BaoCaoTongHop_ThucHienNSNN,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_thuchien_nsnn2 = {
  id: BaoCao.BC220_BaoCaoTongHop_ThucHienNSNN2,
  text: 'BC tổng hợp tình hình thực hiện NSNN(mẫu 2023)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_thuchien_nsnn2/' + BaoCao.BC220_BaoCaoTongHop_ThucHienNSNN2,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_bangcandoisophatsinh = {
  id: BaoCao.BC218_BaoCaoTongHop_BangCanDoiSoPhatSinh,
  text: 'BC tổng hợp bảng cân đối số phát sinh(S05-H)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_bangcandoisophatsinh/' + BaoCao.BC218_BaoCaoTongHop_BangCanDoiSoPhatSinh,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_thongtintaikhoanc03 = {
  id: BaoCao.BC219_BaoCaoTongHop_ThongTinTaiSanC03,
  text: 'BC tổng hợp thông tin tài sản(C03/CCTT)-TT39',
  link: '/baocaoquyettoan/baocaotonghop_taisanc03/' + BaoCao.BC219_BaoCaoTongHop_ThongTinTaiSanC03,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_tinhhinhtanggiamtscd = {
  id: BaoCao.BC221_BaoCaoTongHop_TinhHinhTangGiamTSCD,
  text: 'BC tổng hợp tình hình tăng giảm TSCĐ-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_tinhhinhtanggiamtscd/' + BaoCao.BC221_BaoCaoTongHop_TinhHinhTangGiamTSCD,
  huongdan: Global.App_url
};



export const QuyetToans_baocaotonghop_bienban_loaikhoanmaumoi = {
  id: BaoCao.BC204_BaoCaoTongHop_BienBan_LoaiKhoan,
  text: 'BC tổng hợp (mẫu biên bản mẫu mới)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_bienban_loaikhoanmaumoi/' + BaoCao.BC204_BaoCaoTongHop_BienBan_LoaiKhoan,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_baocao_tatca = {
  id: BaoCao.BC205_BaoCaoTongHop_BaoCao_TatCa,
  text: 'BC tổng hợp (mẫu báo cáo tất cả)',
  link: '/baocaoquyettoan/baocaotonghop_baocao_tatca/' + BaoCao.BC205_BaoCaoTongHop_BaoCao_TatCa,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_baocao_loaikhoan = {
  id: BaoCao.BC206_BaoCaoTongHop_BaoCao_LoaiKhoan,
  text: 'BC tổng hợp (mẫu báo cáo in theo khoản)',
  link: '/baocaoquyettoan/baocaotonghop_baocao_loaikhoan/' + BaoCao.BC206_BaoCaoTongHop_BaoCao_LoaiKhoan,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghop_baocao_loaikhoanmaumoi = {
  id: BaoCao.BC206_BaoCaoTongHop_BaoCao_LoaiKhoan,
  text: 'BC tổng hợp (mẫu báo cáo mẫu mới) - TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghop_baocao_loaikhoanmaumoi/' + BaoCao.BC206_BaoCaoTongHop_BaoCao_LoaiKhoan,
  huongdan: Global.App_url
};

export const QuyetToans_bienbanquyetoanchingansach = {
  id: BaoCao.BC207_BienBanQuyettoanChiNganSach,
  text: 'Biên bản quyết toán chi ngân sách',
  link: '/baocaoquyettoan/bienbanquyetoanchingansach/' + BaoCao.BC207_BienBanQuyettoanChiNganSach,
  huongdan: Global.App_url
};

export const QuyetToans_baocaokiemtraloi = {
  id: BaoCao.BC208_BaoCaoKiemTraLoi,
  text: 'Báo cáo kiểm tra lỗi dữ liệu',
  link: '/baocaoquyettoan/baocaokiemtraloi/' + BaoCao.BC208_BaoCaoKiemTraLoi,
  huongdan: Global.App_url
};
export const QuyetToans_baocaothuphilephi = {
  id: BaoCao.BC209_BaoCaoTHThuPhiLePhi,
  text: 'Báo cáo TH thu phí, lệ phí',
  link: '/baocaoquyettoan/baocaothuphilephi/' + BaoCao.BC209_BaoCaoTHThuPhiLePhi,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotonghopketquahoatdong1b02 = {
  id: BaoCao.BC210_BaoCaoKetQuaHoatDong1b02,
  text: 'BC tổng hợp kết quả hoạt động(mẫu 1b - B02)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotonghopketquahoatdong1b02/' + BaoCao.BC210_BaoCaoKetQuaHoatDong1b02,
  huongdan: Global.App_url
};


export const QuyetToans_baocaotonghopketquahoatdong1b05 = {
  id: BaoCao.BC211_BaoCaoKetQuaHoatDong1b05,
  text: 'BC tổng hợp kết quả hoạt động(mẫu 1b - B05)-TT107',
  link: '/baocaoquyettoan/baocaotonghopketquahoatdong1b05/' + BaoCao.BC211_BaoCaoKetQuaHoatDong1b05,
  huongdan: Global.App_url
};

export const QuyetToans_quyettoanthuchinguonnsnn = {
  id: BaoCao.BC212_QuyetToanThuChiNguonNSNN,
  text: 'Quyết toán thu chi nguồn NSNN, nguồn khác',
  link: '/baocaoquyettoan/quyettoanthuchinguonnsnn/' + BaoCao.BC212_QuyetToanThuChiNguonNSNN,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotaichinh = {
  id: BaoCao.BC213_BaoCaoTinhHinhTaiChinh_B01_BCTC,
  text: 'BC tình hình tài chính (B01/BCTC)-TT107, TT24',
  link: '/baocaoquyettoan/baocaotaichinh/' + BaoCao.BC213_BaoCaoTinhHinhTaiChinh_B01_BCTC,
  huongdan: Global.App_url
};
export const QuyetToans_baocaoluuchuyentiente = {
  id: BaoCao.BC214_BaoCaoLuuChuyenTienTe_B03a_BCTC,
  text: 'BC lưu chuyển tiền tệ (B03a/BCTC-TT107, TT24)',
  link: '/baocaoquyettoan/baocaoluuchuyentiente/' + BaoCao.BC214_BaoCaoLuuChuyenTienTe_B03a_BCTC,
  huongdan: Global.App_url
};

export const QuyetToans_baocaoluuchuyentienteb = {
  id: BaoCao.BC214_BaoCaoLuuChuyenTienTe_B03b_BCTC,
  text: 'BC lưu chuyển tiền tệ (B03b/BCTC)-TT108',
  link: '/baocaoquyettoan/baocaoluuchuyentienteb/' + BaoCao.BC214_BaoCaoLuuChuyenTienTe_B03b_BCTC,
  huongdan: Global.App_url
};

export const QuyetToans_thuyetminhbaocaotaichinh = {
  id: BaoCao.BC215_BaoCaoThuyetMinhTaiChinh,
  text: 'BC thuyết minh báo cáo tài chính(B04/BCTC)-TT107, TT24',
  link: '/baocaoquyettoan/thuyetminhbaocaotaichinh/' + BaoCao.BC215_BaoCaoThuyetMinhTaiChinh,
  huongdan: Global.App_url
};

export const QuyetToans_baocaobosungthongtintaichinh = {
  id: BaoCao.BC216_BaoCaoBoSungThongTinTaiChinh_B01_BSTT,
  text: 'BC bổ sung thông tin tài chính (B01/BSTT) - TT99',
  link: '/baocaoquyettoan/baocaobosungthongtintaichinh/' + BaoCao.BC216_BaoCaoBoSungThongTinTaiChinh_B01_BSTT,
  huongdan: Global.App_url
};

export const QuyetToans_baocaotaichinh_b05_bctc = {
  id: '8EE95C4C-5D79-43B3-88EB-8EF4DEF403CD',
  text: 'Báo cáo tổng hợp về những thay đổi trong tài sản thuần-TT24',
  link: '/baocaoquyettoan/baocaotaichinhb05_24/8EE95C4C-5D79-43B3-88EB-8EF4DEF403CD',
  huongdan: Global.App_url
};


export const QuyetToans = {
  id: '',
  text: ' Quyết toán',
  link: '/quyettoans',
  icon: 'fas fa-money-check-alt',
  submenu: [
    {
      id: '',
      text: 'Nhập số liệu',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          QuyetToans_baocaochitietkinhphimaumoi,
          QuyetToans_baocaotonghopkinhphimaumoi,
          QuyetToans_baocaothuchihoatdongsunghiep,
          QuyetToans_baothuphi1a, 
          QuyetToans_baocaoketquahoatdong1b02,
          QuyetToans_baocaoketquahoatdong1b05,
         // QuyetToans_baocaoketquahoatdongb02_24,
         // QuyetToans_danhmucchitieu1a,
          QuyetToans_baocaotaichinh_b01bctc,
          QuyetToans_luuchuyentiente_b03abctc,
          QuyetToans_luuchuyentiente_b03bbctc,
          QuyetToans_thuyetminhtaichinh,
          QuyetToans_nhapbaocaobosungthongtintaichinh,
          QuyetToans_nhapbangcandoiphatsinh,
          QuyetToans_thongtintaisanc03,
          QuyetToans_baocaotinhhinhthuchien_nsnn2,
          QuyetToans_nhapbaocaotinhhinhtanggiamtscd,
          QuyetToans_baocaotinhhinhthuchien_nsnn,
          QuyetToans_baocaotaichinh_b05bctc,
          //QuyetToans_baocaochitietkinhphi,
          //QuyetToans_baocaotonghopkinhphi,

        ]
    }
    ,
    QuyetToans_khoasolieubaocao
    ,
    {
      id: '',
      text: 'Báo cáo',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [

        //QuyetToans_tonghopchitietkinhphi_donvi, không dùng
        QuyetToans_tonghopchitietkinhphi_thmaumoi,
        QuyetToans_baocaotonghop_bienban_tatcamaumoi,
        QuyetToans_baocaotonghop_bienban_loaikhoanmaumoi,
        QuyetToans_baocaotonghop_baocao_loaikhoanmaumoi,
        QuyetToans_baocaotonghopketquahoatdong1b02,
        QuyetToans_baocaotonghopketquahoatdong1b05,
        

        QuyetToans_baocaotaichinh,
        QuyetToans_baocaoluuchuyentiente,
        QuyetToans_baocaoluuchuyentienteb,
        QuyetToans_thuyetminhbaocaotaichinh,
        QuyetToans_baocaobosungthongtintaichinh,
        QuyetToans_baocaotonghop_bangcandoisophatsinh,
        QuyetToans_baocaotonghop_thongtintaikhoanc03,
        QuyetToans_baocaotonghop_thuchien_nsnn2,
        QuyetToans_baocaotonghop_tinhhinhtanggiamtscd,
        QuyetToans_baocaotonghop_thuchien_nsnn,
        QuyetToans_baocaothuchihoatdongsunghiepdichvu,
        QuyetToans_baocaothuphilephi,
        QuyetToans_baocaotaichinh_b05_bctc,

        //QuyetToans_tonghopbaocao_xml,

        QuyetToans_baocaokiemtraloi,
        

        
        
      ]
    },
    {
      id: '',
      text: 'Báo cáo khác',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [

        QuyetToans_baocaoquyettoanthuchingansach_bieuso8,
        QuyetToans_tonghopchitietkinhphi_th,
        QuyetToans_baocaotonghop_bienban_tatca,
        QuyetToans_baocaotonghop_bienban_loaikhoan,
        QuyetToans_baocaotonghop_baocao_tatca,
        QuyetToans_baocaotonghop_baocao_loaikhoan,
        QuyetToans_bienbanquyetoanchingansach,
        QuyetToans_quyettoanthuchinguonnsnn,
        
      ]
    },
    {
      id: '',
      text: 'Cấu hình',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          QuyetToans_cauhinhchitieubaocaochitiet,

          QuyetToans_cauhinhchitieubaocaochitietmaumoi,

          QuyetToans_cauhinhchitieuthuchisunghiep,
          QuyetToans_cauhinhchitieumau1a,
        ]
    },
    {
      id: '',
      text: 'Danh mục',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          QuyetToans_quyettoanloaikhoan,

          QuyetToans_quyettoanloaikhoanchung,

          QuyetToans_chitieuthuchihoatdongsunghiep,
          QuyetToans_danhmuctieumuc,
          QuyetToans_danhmucchitieu1a,
          QuyetToans_danhmucchitieu1b02,
          QuyetToans_danhmucchitieu1b05,
        ]
    }

  ]
};
//--- quyết toán


export const menu = [
    Home,
  tiens, 
  KhoBacs,  
  TaiSans,
 congcus,
   Products,
  Payroll,
    Reports,
    Ultil,
  Lists,
  DuToans,
  QuyetToans,
  System
];
